export default {
  translation: {
    // Common
    "app.name": "Give Protocol",
    "app.tagline":
      "Infrastructure transparente et sans frontières pour la générosité.",
    "common.skipToMainContent": "Passer au contenu principal",
    "common.cancel": "Annuler",
    "common.edit": "Modifier",
    "common.delete": "Supprimer",
    "common.creating": "Création...",
    "common.unknown": "Inconnu",
    "common.notAvailable": "N/D",

    // Navigation
    "nav.browse": "Parcourir les Organisations",
    "nav.opportunities": "Opportunités de Bénévolat",
    "nav.contributions": "Suivi des Contributions",
    "nav.governance": "Gouvernance",
    "nav.dashboard": "Tableau de Bord",
    "nav.about": "À Propos",
    "nav.docs": "Documentation",
    "nav.legal": "Mentions Légales",
    "nav.launchApp": "Lancer l'Application",

    // FAQ page (GIV-988)
    "faq.title": "Foire aux questions",
    "faq.subtitle":
      "Tout ce que vous devez savoir sur les dons, le bénévolat et la transparence de la blockchain.",

    // Settings
    "settings.title": "Paramètres",
    "settings.language": "Langue",
    "settings.currency": "Devise",

    // Auth
    "auth.login": "Connexion",
    "auth.register": "Créer un Compte",
    "auth.logout": "Déconnexion",
    "auth.forgotPassword": "Mot de passe oublié ?",

    // Dashboard
    "dashboard.title": "Tableau de Bord",
    "dashboard.subtitle": "Suivez vos dons et contributions bénévoles",
    "dashboard.totalDonations": "Total des Dons",
    "dashboard.volunteerHours": "Heures de Bénévolat",
    "dashboard.skillsEndorsed": "Compétences Approuvées",
    "dashboard.contributions": "Contributions",
    "dashboard.yourTotalDonated": "Vos Dons Totaux",
    "dashboard.yourVolunteerHours": "Vos Heures de Bénévolat",
    "dashboard.yourSkillsEndorsed": "Vos Compétences Approuvées",
    "dashboard.impactGrowth": "Croissance de l'Impact",
    "dashboard.charitiesSupported": "Organisations Soutenues",

    // Charity
    "charity.dashboard": "Tableau de Bord de l'Organisation",
    "charity.subtitle": "Gérez vos dons et programmes de bénévolat",
    "charity.activeVolunteers": "Bénévoles Actifs",
    "charity.transactions": "Transactions",
    "charity.volunteers": "Heures de Bénévolat",
    "charity.applications": "Candidatures",
    "charity.totalReceived": "Total Reçu",
    "charity.equityPoolValue": "Valeur du Pool d'Équité",
    "charity.availableBalance": "Solde Disponible",

    // Contributions
    "contributions.date": "Date",
    "contributions.type": "Type",
    "contributions.organization": "Organisation",
    "contributions.details": "Détails",
    "contributions.status": "Statut",
    "contributions.verification": "Vérification",
    "contributions.export": "Exporter CSV",

    // Volunteer
    "volunteer.opportunities": "Opportunités de Bénévolat",
    "volunteer.searchOpportunities": "Rechercher des opportunités...",
    "volunteer.selectSkill": "Sélectionner une compétence",
    "volunteer.selectType": "Sélectionner un type",
    "volunteer.selectLanguage": "Sélectionner une langue",
    "volunteer.allSkills": "Toutes les Compétences",
    "volunteer.allTypes": "Tous les Types",
    "volunteer.allLanguages": "Toutes les Langues",
    "volunteer.applyNow": "Postuler Maintenant",
    "volunteer.noOpportunitiesFound":
      "Aucune opportunité correspondant à vos critères.",
    "volunteer.verify": "Vérifier les Heures",
    "volunteer.verifying": "Vérification...",
    "volunteer.reject": "Refuser",
    "volunteer.accept": "Accepter",
    "volunteer.processing": "Traitement...",
    "volunteer.hours": "heures le",
    "volunteer.description": "Description",
    "volunteer.appliedFor": "A postulé pour",
    "volunteer.verificationComplete": "Vérification Terminée",
    "volunteer.hoursVerified":
      "Les heures de bénévolat ont été vérifiées et enregistrées sur la blockchain.",
    "volunteer.verificationHash": "Hash de Vérification",
    "volunteer.applicationAccepted": "Candidature Acceptée",
    "volunteer.applicationRecorded":
      "La candidature bénévole a été acceptée et enregistrée sur la blockchain.",
    "volunteer.acceptanceHash": "Hash d'Acceptation",
    "volunteer.pendingHours": "Heures de Bénévolat en Attente",
    "volunteer.noPendingHours":
      "Aucune heure de bénévolat en attente de vérification.",
    "volunteer.pendingApplications": "Candidatures en Attente",
    "volunteer.noPendingApplications":
      "Aucune candidature en attente à examiner.",
    "volunteer.createOpportunity": "Créer une Opportunité de Bénévolat",
    "volunteer.createNew": "Créer",
    "volunteer.noOpportunitiesYet":
      "Aucune opportunité créée. Cliquez sur « Créer » pour commencer.",
    "volunteer.opportunityTitle": "Titre de l'Opportunité",
    "volunteer.skills": "Compétences (séparées par des virgules)",
    "volunteer.commitment": "Engagement",
    "volunteer.location": "Lieu",
    "volunteer.type": "Type",
    "volunteer.workLanguage": "Langue de Travail",
    "volunteer.status": "Statut",

    // Volunteer commitment types
    "volunteer.commitment.oneTime": "Ponctuel",
    "volunteer.commitment.shortTerm": "Court terme",
    "volunteer.commitment.longTerm": "Long terme",

    // Volunteer types
    "volunteer.type.remote": "À distance",
    "volunteer.type.onsite": "Sur place",
    "volunteer.type.hybrid": "Hybride",
    "volunteer.type.onSite": "Sur place",

    // Volunteer - Opportunities page
    "volunteer.workTypeFilter": "Filtre de type de travail",
    "volunteer.searchLocation": "Ville ou région...",
    "volunteer.searchLocationAria": "Rechercher un lieu",
    "volunteer.filter.skill": "Compétence : {{value}}",
    "volunteer.filter.type": "Type : {{value}}",
    "volunteer.filter.language": "Langue : {{value}}",
    "volunteer.filter.location": "Lieu : {{value}}",
    "volunteer.loadingOpportunities": "Chargement des opportunités...",
    "volunteer.loadOpportunitiesError": "Impossible de charger les opportunités de bénévolat. Veuillez réessayer plus tard.",
    "volunteer.viewDetails": "Voir les détails",
    "volunteer.backToOpportunities": "Retour aux opportunités",
    "volunteer.detail.about": "À propos de cette opportunité",
    "volunteer.detail.skills": "Compétences requises",
    "volunteer.detail.commitment": "Engagement de temps",
    "volunteer.detail.location": "Lieu",
    "volunteer.detail.language": "Langue",
    "volunteer.detail.hostedBy": "Organisé par",
    "volunteer.detail.ongoing": "En cours",
    "volunteer.detail.applicationsClosed": "Candidatures closes",
    "volunteer.detail.notFoundTitle": "Opportunité introuvable",
    "volunteer.detail.notFoundMessage": "Cette opportunité a peut-être été pourvue ou supprimée.",
    "volunteer.field.requirements": "Exigences",
    "volunteer.field.benefits": "Avantages",
    "volunteer.field.schedule": "Horaire",
    "volunteer.field.schedulePlaceholder": "p. ex. mardis 18 h-20 h, week-ends flexibles",
    "volunteer.field.startDate": "Date de début",
    "volunteer.field.endDate": "Date de fin",
    "volunteer.field.endDateHelp": "Laisser vide si en cours",
    "volunteer.field.applicationDeadline": "Date limite de candidature",
    "volunteer.field.volunteersNeeded": "Bénévoles recherchés",
    "volunteer.field.minimumAge": "Âge minimum",
    "volunteer.field.backgroundCheckRequired": "Vérification des antécédents requise",
    "volunteer.field.trainingProvided": "Formation fournie",
    "volunteer.field.onePerLine": "un par ligne",
    "volunteer.validation.volunteersNeeded": "Saisissez un nombre supérieur ou égal à 1",
    "volunteer.validation.minimumAge": "Saisissez un âge entre 0 et 120",
    "volunteer.validation.endDate": "La date de fin doit être postérieure ou égale à la date de début",
    "volunteer.signInToApply":
      "Connectez-vous pour postuler aux opportunités de bénévolat",
    "volunteer.applicationSuccess": "Candidature envoyée avec succès !",
    "volunteer.removeFilter": "Retirer le filtre {{filter}}",

    // Volunteer - OpportunityForm
    "volunteer.validation.titleRequired": "Le titre est requis",
    "volunteer.validation.descriptionRequired": "La description est requise",
    "volunteer.validation.skillsRequired":
      "Au moins une compétence est requise",
    "volunteer.validation.locationRequired": "Le lieu est requis",
    "volunteer.profileNotFound": "Profil utilisateur introuvable",
    "volunteer.correctErrors": "Veuillez corriger les erreurs de validation",
    "volunteer.createFailed": "Échec de la création de l'opportunité",
    "volunteer.descriptionPlaceholder":
      "Décrivez l'opportunité de bénévolat en détail...",
    "volunteer.skillsPlaceholder":
      "ex., Développement Web, Gestion de Projet, Traduction",
    "volunteer.locationPlaceholder": "ex., À distance, Paris, Berlin",
    "volunteer.headerImage": "Image d'En-tête",
    "volunteer.headerImageHelp":
      "Téléchargez une image à afficher en haut de votre annonce",
    "volunteer.limitReached": "Limite d'Opportunités Atteinte",
    "volunteer.limitReachedMessage":
      "Vous avez atteint le maximum de {{max}} opportunités de bénévolat actives. Veuillez fermer ou terminer une opportunité existante avant d'en créer une nouvelle.",
    "volunteer.opportunityCount":
      "Vous avez {{count}} sur {{max}} opportunités actives.",

    // Volunteer - HoursVerificationTab
    "volunteer.hoursVerification": "Vérification des Heures",
    "volunteer.hoursVerificationDescription":
      "Examinez et vérifiez les soumissions d'heures de bénévolat",
    "volunteer.formalHours": "Heures Enregistrées",
    "volunteer.selfReported": "Auto-déclarées",
    "volunteer.loggedHours": "Heures de Bénévolat Enregistrées",
    "volunteer.loggedHoursDescription":
      "Heures enregistrées par les bénévoles via vos opportunités",
    "volunteer.allCaughtUp": "Tout est à jour !",
    "volunteer.noPendingLoggedHours":
      "Aucune heure enregistrée en attente de vérification.",
    "volunteer.selfReportedHours": "Heures Auto-déclarées",

    // Volunteer - OpportunitiesTab
    "volunteer.noOpportunitiesTitle": "Aucune opportunité",
    "volunteer.activeCount": "{{count}} sur {{max}} opportunités actives",
    "volunteer.moreSkills": "+{{count}} de plus",

    // Volunteer - ApplicationsTab
    "volunteer.noApplications": "Aucune candidature en attente",
    "volunteer.unknownOpportunity": "Opportunité Inconnue",

    // Volunteer - VerificationLookup
    "volunteer.verifyContribution": "Vérifier une Contribution Bénévole",
    "volunteer.hashPlaceholder": "Entrez le hash de vérification",
    "volunteer.searching": "Recherche...",
    "volunteer.verifyHash": "Vérifier le Hash",
    "volunteer.verificationNotFound": "Vérification Introuvable",
    "volunteer.verificationNotFoundMessage":
      "Le hash fourni n'a pas été trouvé dans nos dossiers. Veuillez vérifier le hash et réessayer.",
    "volunteer.unknownOrganization": "Organisation Inconnue",

    // Volunteer - VolunteerVerificationCard
    "volunteer.contributionVerification":
      "Vérification de Contribution Bénévole",
    "volunteer.volunteerLabel": "Bénévole",
    "volunteer.opportunityLabel": "Opportunité",
    "volunteer.organizationLabel": "Organisation",
    "volunteer.acceptedOn": "Accepté le",
    "volunteer.verifiedOn": "Vérifié le",
    "volunteer.verificationHashes": "Hash de Vérification",
    "volunteer.blockchainReference": "Référence Blockchain",

    // Volunteer - VerifyContribution page
    "volunteer.verifyingContribution": "Vérification de la contribution\u2026",
    "volunteer.noHashProvided": "Aucun hash de vérification fourni.",
    "volunteer.verificationSuccessful": "Vérification Réussie",
    "volunteer.contributionVerifiedBlockchain":
      "Cette contribution bénévole a été vérifiée et enregistrée sur la blockchain.",
    "volunteer.verificationFailed": "Vérification Échouée",
    "volunteer.hashNotFound":
      "Le hash de vérification {{hash}} est introuvable ou invalide.",

    // Volunteer - SelfReportedHoursDashboard
    "volunteer.volunteerHoursTitle": "Heures de Bénévolat",
    "volunteer.aboutSelfReported": "À propos des Heures Auto-déclarées",
    "volunteer.selfReportedInfo":
      "Seules les heures validées par des organisations vérifiées comptent pour les Classements d'Impact Global. Les heures pour des organisations hors de la plateforme peuvent être enregistrées mais seront marquées comme \u00ab Non Validées \u00bb jusqu'à validation.",
    "volunteer.logHoursButton": "Enregistrer des Heures",
    "volunteer.logVolunteerHours": "Enregistrer des Heures de Bénévolat",
    "volunteer.editRecord": "Modifier l'Enregistrement",
    "volunteer.recordDetails": "Détails de l'Enregistrement",
    "volunteer.backToList": "Retour à la Liste",
    "volunteer.deleteRecord": "Supprimer l'Enregistrement ?",
    "volunteer.deleteConfirmation":
      "Êtes-vous sûr de vouloir supprimer cet enregistrement d'heures de bénévolat ? Cette action est irréversible.",

    // Volunteer - SelfReportedHoursForm
    "volunteer.activityType": "Type d'Activité",
    "volunteer.organization": "Organisation",
    "volunteer.searchRegistry": "Rechercher dans le Registre",
    "volunteer.searchRegistryPlaceholder":
      "Rechercher dans le registre des organismes par nom ou ID fiscal…",
    "volunteer.registryTaxId": "ID fiscal {{value}}",
    "volunteer.notListed": "Non Répertoriée",
    "volunteer.organizationName": "Nom de l'Organisation",
    "volunteer.enterOrgName": "Entrez le nom de l'organisation",
    "volunteer.contactEmail": "E-mail de Contact",
    "volunteer.contactEmailOptional": "(facultatif)",
    "volunteer.onboardHelp":
      "Nous pourrons vous contacter pour intégrer cette organisation",
    "volunteer.submittedForValidation":
      "Cet enregistrement sera soumis pour validation",
    "volunteer.submittedForValidationTo":
      "Cet enregistrement sera soumis pour validation à {{org}}",
    "volunteer.validationExpired":
      "La période de validation a expiré pour cette date",
    "volunteer.savedAsUnvalidated":
      "Cet enregistrement sera enregistré comme non validé",
    "volunteer.describeActivities":
      "Décrivez les activités que vous avez réalisées...",
    "volunteer.moreCharsNeeded":
      "{{count}} caractères supplémentaires nécessaires",
    "volunteer.updating": "Mise à jour...",
    "volunteer.logging": "Enregistrement...",
    "volunteer.updateHours": "Mettre à Jour les Heures",

    // Volunteer - SelfReportedHoursList
    "volunteer.statusFilter": "Statut",
    "volunteer.activityTypeFilter": "Type d'Activité",
    "volunteer.filterFrom": "De",
    "volunteer.filterTo": "À",
    "volunteer.clearFilters": "Effacer les filtres",
    "volunteer.allStatuses": "Tous",
    "volunteer.allActivityTypes": "Tous les Types",
    "volunteer.noMatchingRecords": "Aucun enregistrement trouvé",
    "volunteer.noHoursLogged": "Aucune heure de bénévolat enregistrée",
    "volunteer.adjustFilters":
      "Essayez d'ajuster vos filtres pour trouver des enregistrements.",
    "volunteer.startLogging":
      "Commencez par enregistrer vos premières heures de bénévolat.",

    // Volunteer - SelfReportedHoursStats
    "volunteer.validatedHours": "Heures Validées",
    "volunteer.pendingValidation": "Validation en Attente",
    "volunteer.unvalidatedHours": "Heures Non Validées",
    "volunteer.rejectedLabel": "Refusées",
    "volunteer.hoursUnit": "hrs",
    "volunteer.recordSingular": "enregistrement",
    "volunteer.recordPlural": "enregistrements",

    // Volunteer - VolunteerApplicationForm
    "volunteer.applicationTitle":
      "Candidature pour une Opportunité de Bénévolat",
    "volunteer.applicationSubtitle":
      "Contribuez à un impact durable grâce à des contributions vérifiées",
    "volunteer.progress.info": "Infos",
    "volunteer.progress.skills": "Compétences",
    "volunteer.progress.consent": "Consentement",
    "volunteer.fieldValid": "C'est bon",
    "volunteer.draftSaved": "Brouillon enregistré",
    "volunteer.personalInfo": "Informations Personnelles",
    "volunteer.firstName": "Prénom",
    "volunteer.lastName": "Nom",
    "volunteer.emailAddress": "Adresse E-mail",
    "volunteer.phoneNumber": "Numéro de Téléphone",
    "volunteer.locationCity": "Ville/Localisation",
    "volunteer.locationCityPlaceholder": "ex., Paris, France",
    "volunteer.timeZone": "Fuseau Horaire",
    "volunteer.selectTimeZone": "Sélectionner un Fuseau Horaire",
    "volunteer.ageRange": "Tranche d'Âge",
    "volunteer.selectAgeRange": "Sélectionner une Tranche d'Âge",
    "volunteer.skillsAndInterests": "Compétences et Intérêts",
    "volunteer.skillsLabel": "Compétences et Domaines d'Intérêt",
    "volunteer.skillPlaceholderFull":
      "Commencez à saisir vos compétences (ex., Programmation Python, Prise de parole en public, Rédaction de subventions)",
    "volunteer.skillPlaceholderShort":
      "Saisissez une compétence et appuyez sur Entrée...",
    "volunteer.commitmentLevel": "Niveau d'Engagement",
    "volunteer.commitmentOneTimeDesc":
      "Projet ponctuel ou tâches de courte durée",
    "volunteer.commitmentShortTermDesc": "Quelques semaines à quelques mois",
    "volunteer.commitmentLongTermDesc":
      "Engagement continu de plusieurs mois ou plus",
    "volunteer.experienceLabel": "Parlez-nous de votre expérience pertinente",
    "volunteer.experiencePlaceholder":
      "Décrivez votre parcours, compétences et ce qui vous motive à être bénévole avec Give Protocol...",
    "volunteer.consentTitle": "Consentement et Accord",
    "volunteer.consentHeader": "Consentement de Candidature Bénévole",
    "volunteer.submitting": "Envoi...",
    "volunteer.submitApplication": "Soumettre la Candidature Bénévole",
    "volunteer.disclaimerText":
      "En soumettant cette candidature, vous reconnaissez avoir lu et compris la politique de confidentialité et les directives pour bénévoles de Give Protocol. Vos données seront traitées conformément aux réglementations applicables en matière de protection des données.",
    "volunteer.validation.firstNameInvalid": "Veuillez entrer un prénom valide",
    "volunteer.validation.lastNameInvalid": "Veuillez entrer un nom valide",
    "volunteer.validation.emailInvalid":
      "Veuillez entrer une adresse e-mail valide",
    "volunteer.validation.phoneInvalid":
      "Veuillez entrer un numéro de téléphone valide",
    "volunteer.validation.experienceRequired":
      "Veuillez décrire votre expérience pertinente",
    "volunteer.validation.addSkill": "Veuillez ajouter au moins une compétence",
    "volunteer.validation.ageRangeRequired":
      "Veuillez sélectionner votre tranche d'âge",
    "volunteer.validation.consentRequired":
      "Vous devez accepter tous les éléments de consentement requis",
    "volunteer.signInToSubmit":
      "Veuillez vous connecter pour soumettre une candidature",
    "volunteer.submitFailed":
      "Échec de l'envoi de la candidature. Veuillez réessayer.",

    // Volunteer - ApplicationForm
    "volunteer.applyForTitle": "Postuler pour : {{title}}",
    "volunteer.fullName": "Nom Complet *",
    "volunteer.phoneRequired": "Numéro de Téléphone *",
    "volunteer.emailRequired": "Adresse E-mail *",
    "volunteer.dateOfBirth": "Date de Naissance",
    "volunteer.availabilityTitle": "Disponibilité",
    "volunteer.preferredDays": "Jours Préférés",
    "volunteer.preferredTimes": "Horaires Préférés",
    "volunteer.commitmentLevelLabel": "Niveau d'Engagement",
    "volunteer.skillsAndExperience": "Compétences et Expérience",
    "volunteer.relevantExperience": "Expérience Pertinente *",
    "volunteer.certifications": "Certifications (séparées par des virgules)",
    "volunteer.interestsAndPreferences": "Intérêts et Préférences",
    "volunteer.areasOfInterest":
      "Domaines d'Intérêt (séparés par des virgules)",
    "volunteer.referencesTitle": "Références",
    "volunteer.referenceName": "Nom de la Référence {{index}}",
    "volunteer.referenceContact": "Contact de la Référence {{index}}",
    "volunteer.workSamplesTitle": "Échantillons de Travail",
    "volunteer.workSamplesLabel":
      "Liens vers des échantillons de travail (séparés par des virgules)",
    "volunteer.submitApplicationShort": "Soumettre la Candidature",
    "volunteer.validation.nameInvalid":
      "Veuillez entrer un nom valide (2-100 caractères)",
    "volunteer.validation.provideExperience":
      "Veuillez fournir des informations sur votre expérience",
    "volunteer.validation.selectDay": "Veuillez sélectionner au moins un jour",
    "volunteer.validation.selectTime":
      "Veuillez sélectionner au moins un horaire",

    // Volunteer - ConsentForm
    "volunteer.consentUnderstand": "Je comprends que :",
    "volunteer.processingAckTitle": "ACCUSÉ DE RÉCEPTION DU TRAITEMENT",
    "volunteer.processingAckDesc":
      "Veuillez examiner et confirmer ce qui suit avant de continuer :",
    "volunteer.essentialProcessingTitle":
      "Traitement de la Candidature (Confirmation requise) :",
    "volunteer.acknowledgmentTitle": "RECONNAISSANCE",
    "volunteer.ageConfirmationTitle": "Confirmation d'Âge :",
    "volunteer.privacyNoticeTitle": "Avis de Confidentialité :",
    "volunteer.doNotAccept": "Ne Pas Accepter",
    "volunteer.acceptAndContinue": "Accepter et Continuer",
    "volunteer.validation.essentialRequired":
      "Vous devez confirmer l'accusé de réception du traitement de la candidature pour continuer",
    "volunteer.validation.agePrivacyRequired":
      "Vous devez confirmer votre âge et avoir lu l'Avis de Confidentialité",

    // Age affirmation gate (shared across all surfaces — GIV-453)
    "ageGate.positive": "Je confirme que j'ai 16 ans ou plus.",
    "ageGate.negative":
      "Give Protocol est disponible pour les utilisateurs âgés de 16 ans ou plus. Si vous avez moins de 16 ans, nous ne sommes pas en mesure de traiter votre demande pour le moment.",

    // Languages
    "language.english": "Anglais",
    "language.spanish": "Espagnol",
    "language.german": "Allemand",
    "language.french": "Français",
    "language.japanese": "Japonais",
    "language.chinese_simplified": "Chinois (Simplifié)",
    "language.chinese_traditional": "Chinois (Traditionnel)",
    "language.thai": "Thaï",
    "language.vietnamese": "Vietnamien",
    "language.korean": "Coréen",
    "language.arabic": "Arabe",
    "language.hindi": "Hindi",
    "language.multiple": "Langues Multiples",

    // Contribution types
    "contribution.type.donation": "Don",
    "contribution.type.volunteerapplication": "Candidature Bénévole",
    "contribution.type.volunteerhours": "Heures de Bénévolat",
    "contribution.type.volunteeracceptance": "Acceptation Bénévole",
    "contribution.type.volunteerverification": "Vérification Bénévole",

    // Donor/Volunteer
    "donor.volunteer": "Donateur/Bénévole",
    "donor.anonymous": "Anonyme",
    "volunteer.unknown": "Bénévole Inconnu",

    // Statuses
    "status.completed": "Terminé",
    "status.pending": "En Attente",
    "status.failed": "Échoué",

    // Blockchain
    "blockchain.block": "Bloc",

    // Filter
    "filter.allYears": "Toutes les Années",
    "filter.allTypes": "Tous les Types",
    "filter.donations": "Dons",
    "filter.volunteerApplications": "Candidatures Bénévoles",
    "filter.volunteerHours": "Heures de Bénévolat",
    "filter.fiatDonations": "Dons en Monnaie Fiduciaire",

    // Export
    "export.title": "Exporter les Données de Contribution",
    "export.filename": "Nom de Fichier",
    "export.dateRange": "Plage de Dates",
    "export.includePersonal": "Inclure les adresses de portefeuille",
    "export.willInclude": "L'exportation inclura :",
    "export.walletAddresses":
      "Adresses de portefeuille (expéditeur et destinataire)",
    "export.volunteerDetails":
      "Détails de contribution bénévole (le cas échéant)",
    "export.verificationHashes": "Hash de vérification (le cas échéant)",
    "export.cancel": "Annuler",
    "export.download": "Exporter CSV",

    // Skills
    "skills.endorsements": "Compétences et Recommandations",

    // Home
    "home.subtitle":
      "Connecter les ressources aux causes qui en ont le plus besoin",
    "home.startDonating": "Commencer à Donner",

    // Modal - shared
    "modal.close": "Fermer la fenêtre",
    "modal.closeAriaLabel": "Fermer",

    // Modal - wallet connection
    "modal.wallet.title": "Connecter Votre Portefeuille",
    "modal.wallet.description":
      "Connectez un portefeuille pour débloquer toutes les fonctionnalités de Give Protocol",
    "modal.wallet.benefit1":
      "Suivez vos dons de manière transparente sur la blockchain",
    "modal.wallet.benefit2":
      "Recevez des jetons GIVE en récompense de vos contributions",
    "modal.wallet.benefit3":
      "Participez aux décisions de gouvernance du protocole",
    "modal.wallet.connecting": "Connexion...",
    "modal.wallet.clickToConnect": "Cliquez pour connecter",
    "modal.wallet.noExtension": "Aucune extension de portefeuille détectée.",
    "modal.wallet.installMetaMask": "Installez MetaMask pour commencer",
    "modal.wallet.skip": "Passer pour l'instant",
    "modal.wallet.footerNote":
      "Vous pouvez connecter votre portefeuille à tout moment depuis la barre de navigation",
    "modal.wallet.failedConnect": "Échec de connexion du portefeuille",

    // Modal - wallet link
    "modal.walletLink.title": "Lier Votre Portefeuille",
    "modal.walletLink.description":
      "Liez un portefeuille à votre compte pour les dons on-chain, les récompenses en jetons et la gouvernance",
    "modal.walletLink.benefit1":
      "Donnez des cryptomonnaies directement aux organisations vérifiées on-chain",
    "modal.walletLink.benefit2Pre": "Développez",
    "modal.walletLink.benefit2Post": "des credentials pour vos contributions",
    "modal.walletLink.benefit3":
      "Connectez-vous par e-mail ou portefeuille \u2014 même compte",
    "modal.walletLink.buttonLinking": "Liaison\u2026",
    "modal.walletLink.buttonLink": "Lier le Portefeuille",
    "modal.walletLink.buttonConnectFirst": "Connecter d'abord le Portefeuille",
    "modal.walletLink.footerNote":
      "Vous pouvez lier votre portefeuille à tout moment depuis les Paramètres",
    "modal.walletLink.failedLink": "Échec de liaison du portefeuille",

    // Modal - chain selection
    "modal.chain.title": "Bienvenue sur Give Protocol",
    "modal.chain.subtitle": "Choisissez votre réseau préféré pour commencer",
    "modal.chain.footerNote":
      "Vous pouvez changer de réseau à tout moment depuis le menu",
    "modal.chain.connecting": "Connexion...",
    "modal.chain.continue": "Continuer",
    "modal.chain.failedSelect": "Échec de sélection du réseau",

    // Modal - network selection (WalletModal step 1)
    "modal.network.title": "Sélectionner le Réseau",
    "modal.network.nextStep": "Étape Suivante : Connecter le Portefeuille",
    "modal.network.learnMore": "En savoir plus sur la sélection de réseau",

    // Modal - wallet connect (WalletModal step 2)
    "modal.connect.title": "Connecter le Portefeuille",
    "modal.connect.backAria": "Retour à la sélection de réseau",
    "modal.connect.noWallets":
      "Aucun portefeuille disponible pour les chaînes {{chainType}}.",
    "modal.connect.tryDifferentChain":
      "Essayez de sélectionner un type de chaîne différent.",
    "modal.connect.viewOtherWallets": "Voir les autres portefeuilles supportés",
    "modal.connect.termsAgreement": "En vous connectant, vous acceptez nos",
    "modal.connect.termsLink": "Conditions de Service",
    "modal.connect.termsPrivacyConnector": "et",
    "modal.connect.privacyLink": "Politique de Confidentialité",
    "modal.connect.chainTypeAria": "Type de chaîne",
    "modal.connect.failedConnect": "Échec de connexion",

    // Modal - donation
    "modal.donation.successTitle": "Merci !",
    "modal.donation.donationProcessedOneTime":
      "Votre don de {{amount}} à {{charityName}} a été traité.",
    "modal.donation.donationProcessedRecurring":
      "Votre don mensuel de {{amount}} à {{charityName}} a été traité.",
    "modal.donation.recurringNote":
      "Vous serez débité mensuellement jusqu'à annulation.",
    "modal.donation.receiptNote":
      "Un reçu a été envoyé à votre adresse e-mail.",
    "modal.donation.done": "Terminé",
    "modal.donation.errorTitle": "Une Erreur Est Survenue",
    "modal.donation.errorDefault":
      "Une erreur inattendue s'est produite. Veuillez réessayer.",
    "modal.donation.tryAgain": "Réessayer",
    "modal.donation.close": "Fermer",
    "modal.donation.amountLabel": "Montant du Don",
    "modal.donation.perMonth": "par mois",
    "modal.donation.monthly": "Mensuel",
    "modal.donation.oneTime": "Ponctuel",
    "modal.donation.loadingPaymentForm":
      "Chargement du formulaire de paiement...",
    "modal.donation.supportMonthly": "Soutenir {{charityName}} Mensuellement",
    "modal.donation.donateToCharity": "Donner à {{charityName}}",

    // Modal - scheduled donation
    "modal.scheduledDonation.title":
      "Programmer des Dons Mensuels à {{charityName}}",

    // Modal - withdrawal
    "modal.withdrawal.title": "Demander un Retrait",

    // Modal - validation response
    "modal.validation.rejectTitle": "Refuser la Demande de Validation",
    "modal.validation.reviewTitle": "Examiner la Demande de Validation",
    "modal.validation.volunteer": "Bénévole",
    "modal.validation.activityDetails": "Détails de l'Activité",
    "modal.validation.date": "Date",
    "modal.validation.hour": "heure",
    "modal.validation.hours": "heures",
    "modal.validation.activityType": "Type d'Activité",
    "modal.validation.location": "Lieu",
    "modal.validation.description": "Description",
    "modal.validation.submitted": "Soumis :",
    "modal.validation.daysRemaining": "({{count}} jours restants pour valider)",
    "modal.validation.appealNote":
      "Ceci est un appel/re-soumission d'une demande précédemment refusée",
    "modal.validation.rejectPrompt":
      "Veuillez sélectionner une raison de refus. Le bénévole sera notifié.",
    "modal.validation.reject": "Refuser",
    "modal.validation.approve": "Approuver",
    "modal.validation.processing": "Traitement...",
    "modal.validation.back": "Retour",
    "modal.validation.confirmRejection": "Confirmer le Refus",
    "modal.validation.selectReasonError":
      "Veuillez sélectionner une raison de refus",

    // Toast
    "toast.dismiss": "Fermer la notification",

    // Error boundary
    "error.somethingWrong": "Une erreur est survenue",
    "error.unexpectedError": "Une erreur inattendue s'est produite",
    "error.tryAgain": "Réessayer",
    "error.tooManyAttempts": "Trop de tentatives",
    "error.goHome": "Retour à l'Accueil",
    "error.details": "Détails de l'Erreur",

    // Validation - rejection reason select
    "validation.rejection.reasonLabel": "Raison du Refus",
    "validation.rejection.reasonPlaceholder": "Sélectionnez une raison...",
    "validation.rejection.notesLabel": "Notes Supplémentaires",
    "validation.rejection.optional": "(facultatif)",
    "validation.rejection.notesPlaceholder":
      "Fournissez un contexte supplémentaire pour le refus...",

    // Validation - batch actions
    "validation.batch.deselectAll": "Tout désélectionner",
    "validation.batch.selectAll": "Tout sélectionner",
    "validation.batch.selected": "{{selected}} sur {{total}} sélectionnés",
    "validation.batch.clear": "Effacer",
    "validation.batch.reject": "Refuser ({{count}})",
    "validation.batch.approve": "Approuver ({{count}})",

    // Dashboard - admin redirect (GIV-254)
    "dashboard.adminTitle": "Panneau d'Administration",
    "dashboard.adminNote":
      "Veuillez utiliser le panneau d'administration pour gérer la plateforme.",
    "dashboard.adminButton": "Aller au Panneau d'Administration",
    "dashboard.logVolunteerHours": "Enregistrer des Heures de Bénévolat",
    "dashboard.hideVolunteerHours": "Masquer les Heures de Bénévolat",
    "dashboard.viewMonthlyDonations": "Voir les Dons Mensuels",
    "dashboard.hideMonthlyDonations": "Masquer les Dons Mensuels",
    "dashboard.walletSettings": "Paramètres du Portefeuille",
    "dashboard.overview": "Vue d'Ensemble",
    "dashboard.lastUpdated": "Dernière mise à jour",
    "dashboard.refreshData": "Actualiser les données",
    "dashboard.searchPlaceholder": "Rechercher projets, bénévoles (Cmd+K)",
    "dashboard.search": "Rechercher",

    // Settings - account section (GIV-254)
    "settings.manageDescription": "Gérez votre compte et vos préférences",
    "settings.account": "Compte",
    "settings.email": "E-mail",
    "settings.displayName": "Nom d'Affichage",
    "settings.authMethod": "Méthode d'Authentification",
    "settings.role": "Rôle",

    // Common additional (GIV-254)
    "common.refresh": "Actualiser",
    "common.all": "Tout",
    "common.loading": "Chargement...",
    "common.close": "Fermer",
    "common.back": "Retour",

    // Cause (GIV-254)
    "cause.createCause": "Créer une Cause",

    // Contribution Tracker (GIV-254)
    "tracker.title": "Classements d'Impact Global",
    "tracker.subtitle":
      "Suivez et célébrez l'impact collectif de notre communauté",
    "tracker.searchPlaceholder": "Rechercher des contributeurs...",
    "tracker.exportCSV": "Exporter CSV",
    "tracker.exportPDF": "Exporter PDF",
    "tracker.hideContributions": "Masquer mes contributions des classements",
    "tracker.yourAlias": "Votre alias :",
    "tracker.changeAlias": "Modifier",
    "tracker.setWalletAlias": "Définir l'Alias du Portefeuille",
    "tracker.aliasTitle": "Définir l'Alias du Portefeuille",
    "tracker.aliasDescription":
      "Votre alias sera affiché sur le suivi des contributions à la place de votre adresse de portefeuille.",
    "tracker.aliasLabel": "Alias",
    "tracker.aliasPlaceholder": "Entrez votre alias préféré",
    "tracker.saveAlias": "Enregistrer l'Alias",
    "tracker.donationRankings": "Classement des Dons",
    "tracker.volunteerRankings": "Classement du Bénévolat",
    "tracker.exportComplete": "Exportation Terminée",
    "tracker.exportDonationCSV": "Classement des dons exporté en CSV",
    "tracker.exportVolunteerCSV": "Classement du bénévolat exporté en CSV",
    "tracker.exportPDFSuccess": "Classement exporté en PDF",
    "tracker.exportFailed": "Échec de l'Exportation",
    "tracker.exportNoData": "Aucune donnée disponible pour l'exportation",
    "tracker.exportError": "Une erreur est survenue lors de l'exportation",
    "tracker.walletNotConnected": "Portefeuille non connecté",
    "tracker.connectWalletForAlias":
      "Veuillez connecter votre portefeuille pour définir un alias",
    "tracker.invalidAlias": "Alias invalide",
    "tracker.enterValidAlias": "Veuillez entrer un alias valide",

    // Charity Portal (GIV-254)
    "charity.portal.deleteTitle": "Supprimer {{type}} ?",
    "charity.portal.deleteDescription":
      "Cette action est irréversible. Le/la {{type}} sera définitivement supprimé(e).",
    "charity.portal.walletNotConfigured":
      "Portefeuille de réception non configuré.",
    "charity.portal.walletDonationNote":
      "Connectez un portefeuille pour recevoir des dons on-chain.",
    "charity.portal.setupWallet": "Configurer le Portefeuille",

    // Charity dashboard onboarding & verification
    "charity.onboarding.ariaLabel": "Liste d'intégration",
    "charity.onboarding.title": "Premiers pas",
    "charity.onboarding.progress":
      "{{completed}} étapes sur {{total}} terminées",
    "charity.onboarding.optional": "Facultatif",
    "charity.onboarding.allComplete":
      "Toutes les étapes sont terminées ! Vous pouvez fermer cette liste.",
    "charity.onboarding.expand": "Développer la liste",
    "charity.onboarding.collapse": "Réduire la liste",
    "charity.onboarding.dismiss": "Fermer la liste d'intégration",
    "charity.onboarding.check": "Cocher {{label}}",
    "charity.onboarding.uncheck": "Décocher {{label}}",
    "charity.onboarding.stepDone": "{{label}} (terminé)",
    "charity.onboarding.stepAuto": "{{label}} (se termine automatiquement)",
    "charity.onboarding.goToOrganization": "Aller à l'organisation",
    "charity.onboarding.setupWallet": "Configurer le portefeuille",
    "charity.onboarding.item.completeProfile.label":
      "Compléter le profil de l'organisation",
    "charity.onboarding.item.completeProfile.description":
      "Ajoutez le nom, la description, l'adresse et les coordonnées de votre organisation.",
    "charity.onboarding.item.uploadLogo.label":
      "Téléverser un logo ou une bannière",
    "charity.onboarding.item.uploadLogo.description":
      "Ajoutez un logo ou une bannière pour aider les donateurs à reconnaître votre association.",
    "charity.onboarding.item.connectWallet.label":
      "Configurer le portefeuille de réception",
    "charity.onboarding.item.connectWallet.description":
      "Choisissez un Safe multisig, une garde institutionnelle ou un portefeuille à signataire unique pour recevoir les dons. Prouvez-en le contrôle en signant un message.",
    "charity.onboarding.item.bankDetails.label":
      "Configurer les coordonnées bancaires pour la conversion en monnaie fiduciaire",
    "charity.onboarding.item.bankDetails.description":
      "Renseignez vos informations bancaires si vous souhaitez accepter les dons par carte.",
    "charity.onboarding.item.acceptTerms.label":
      "Lire et accepter les conditions d'utilisation",
    "charity.onboarding.item.acceptTerms.description":
      "Lisez et confirmez les conditions générales de Give Protocol pour les associations.",
    "charity.verification.pendingTitle": "Demande en cours d'examen",
    "charity.verification.pendingBody":
      "Notre équipe examine la demande de votre association. Cela prend généralement de 3 à 5 jours ouvrés. Nous vous enverrons un e-mail dès qu'une décision sera prise.",
    "charity.verification.rejectedTitle": "Demande non approuvée",
    "charity.verification.reason": "Motif : {{notes}}",
    "charity.verification.rejectedDefault":
      "Votre demande n'a pas été approuvée pour le moment.",
    "charity.verification.contactSupport": "Contacter l'assistance",
    "charity.verification.suspendedTitle": "Compte suspendu",
    "charity.verification.suspendedDefault":
      "Le compte de votre association a été suspendu.",
    "charity.verification.appealSuspension": "Contester la suspension",
    "charity.verification.verifiedTitle": "Association vérifiée",
    "charity.verification.verifiedBody":
      "Votre organisation est vérifiée et les donateurs peuvent désormais soutenir vos causes.",
    "charity.portal.receivingWallet": "Portefeuille de réception : {{address}}",
    "charity.portal.loadError":
      "Impossible de charger les données de l'association. Veuillez réessayer.",

    // Timestamps (GIV-254)
    "timestamp.justNow": "À l'instant",
    "timestamp.oneMinuteAgo": "Il y a 1 minute",
    "timestamp.minutesAgo": "Il y a {{count}} minutes",

    // Common additions (GIV-256)
    "common.previous": "Précédent",
    "common.next": "Suivant",
    "common.pageOfTotal": "Page {{page}} sur {{total}}",
    "common.retry": "Réessayer",
    "common.processing": "Traitement...",
    "common.saving": "Enregistrement...",
    "common.donate": "Donner",
    "common.active": "Actif",

    // Portfolio Funds - public page (GIV-256)
    "portfolio.donationType": "Type de Don",
    "portfolio.devNative": "DEV (Natif)",
    "portfolio.testToken": "Jeton TEST",
    "portfolio.donationAmount": "Montant du Don :",
    "portfolio.platformFee": "Frais de Plateforme ({{percentage}}%) :",
    "portfolio.toCharities": "Aux Organisations :",
    "portfolio.eachCharityReceives": "Chaque organisation reçoit :",
    "portfolio.donateToFund": "Donner à {{name}}",
    "portfolio.equalDistribution": "Distribution Égale",
    "portfolio.equalDistributionNote":
      "Votre don sera réparti également entre {{count}} organisations vérifiées.",
    "portfolio.eachCharityPercentage":
      "Chaque organisation reçoit {{percentage}}% des dons",
    "portfolio.verifiedCharities": "{{count}} Organisations Vérifiées",
    "portfolio.donateToFundButton": "Donner au Fonds",
    "portfolio.noFundsAvailable": "Aucun fonds de portefeuille disponible",
    "portfolio.checkBackLater":
      "Revenez plus tard pour de nouvelles opportunités de financement",
    "portfolio.amountLabel": "Montant ({{currency}})",
    "portfolio.invalidAmount": "Veuillez entrer un montant valide",
    "portfolio.donationSuccess": "Don réussi !",
    "portfolio.donationFailed": "Échec du don. Veuillez réessayer.",

    // Admin - Activity event type labels (GIV-256)
    "admin.activity.donation": "Don",
    "admin.activity.registration": "Inscription",
    "admin.activity.verification": "Vérification",
    "admin.activity.volunteerHours": "Heures de Bénévolat",
    "admin.activity.default": "Activité",

    // Admin - Dashboard page (GIV-256)
    "admin.dashboard.title": "Panneau d'Administration",
    "admin.dashboard.alerts": "Alertes",
    "admin.dashboard.alertsPending": "{{count}} en attente",
    "admin.dashboard.alertsView": "Voir",
    "admin.dashboard.recentActivity": "Activité Récente",
    "admin.dashboard.noRecentActivity": "Aucune activité récente.",
    "admin.dashboard.quickActions": "Actions Rapides",
    "admin.dashboard.errorTitle": "Erreur de Chargement du Panneau",
    "admin.stats.last7d": "7 derniers j.",
    "admin.stats.last30d": "30 derniers j.",
    "admin.stats.totalDonors": "Total des Donateurs",
    "admin.stats.newRegistrations": "nouvelles inscriptions",
    "admin.stats.charities": "Organisations",
    "admin.stats.pendingVerification": "vérification en attente",
    "admin.stats.verifiedCharities": "Organisations Vérifiées",
    "admin.stats.activeVolunteers": "Bénévoles Actifs",
    "admin.stats.totalDonationVolume": "Volume Total des Dons",
    "admin.stats.cryptoVolume": "Volume Crypto",
    "admin.stats.fiatVolume": "Volume Fiduciaire",
    "admin.stats.donations": "dons",

    // Admin - Quick Actions (GIV-256)
    "admin.actions.viewReports": "Voir les Rapports",
    "admin.actions.viewReportsDesc": "Générer des analyses détaillées",
    "admin.actions.manageCharities": "Gérer les Organisations",
    "admin.actions.manageCharitiesDesc":
      "Examiner et approuver les organisations",
    "admin.actions.systemSettings": "Paramètres du Système",
    "admin.actions.systemSettingsDesc":
      "Configurer les paramètres de la plateforme",
    "admin.actions.manageImpactMetrics": "Gérer les Métriques d'Impact",
    "admin.actions.manageImpactMetricsDesc":
      "Configurer les données du calculateur d'impact",
    "admin.actions.donationMonitoring": "Suivi des Dons",
    "admin.actions.donationMonitoringDesc":
      "Surveiller, signaler et rapporter les dons",
    "admin.actions.contentModeration": "Modération de Contenu",
    "admin.actions.contentModerationDesc":
      "Masquer, signaler et examiner les opportunités et causes",
    "admin.actions.portfolioFunds": "Fonds de Portefeuille",
    "admin.actions.portfolioFundsDesc":
      "Créer et gérer des portefeuilles de dons",
    "admin.actions.charityRequests": "Demandes d'Organisations",
    "admin.actions.charityRequestsDesc":
      "Examiner les demandes de donateurs pour des organisations non inscrites",

    // Admin - Portfolio Funds management page (GIV-256)
    "admin.portfolio.title": "Fonds de Portefeuille",
    "admin.portfolio.subtitle":
      "Créer et gérer des portefeuilles de dons curatés",
    "admin.portfolio.newFund": "Nouveau Fonds",
    "admin.portfolio.editFund": "Modifier le Fonds",
    "admin.portfolio.createNewFund": "Créer un Nouveau Fonds",
    "admin.portfolio.fundName": "Nom du Fonds",
    "admin.portfolio.fundNamePlaceholder":
      "ex., Fonds d'Impact Environnemental",
    "admin.portfolio.description": "Description",
    "admin.portfolio.descriptionPlaceholder":
      "Décrivez l'objectif et le focus d'impact du fonds...",
    "admin.portfolio.category": "Catégorie",
    "admin.portfolio.selectCategory": "Sélectionner une catégorie",
    "admin.portfolio.imageUrl": "URL de l'Image",
    "admin.portfolio.imageUrlPlaceholder": "https://...",
    "admin.portfolio.selectCharities":
      "Sélectionner des Organisations ({{count}} sélectionnées)",
    "admin.portfolio.noCharitiesFound": "Aucune organisation vérifiée trouvée",
    "admin.portfolio.saving": "Enregistrement...",
    "admin.portfolio.createFund": "Créer le Fonds",
    "admin.portfolio.updateFund": "Mettre à Jour le Fonds",
    "admin.portfolio.noFundsYet": "Aucun fonds de portefeuille pour l'instant",
    "admin.portfolio.noFundsMessage":
      "Créez votre premier fonds pour regrouper des organisations pour des dons groupés",
    "admin.portfolio.charity": "organisation",
    "admin.portfolio.charities": "organisations",
    "admin.portfolio.createdOn": "Créé le {{date}}",
    "admin.portfolio.statusActive": "actif",
    "admin.portfolio.statusPaused": "en pause",
    "admin.portfolio.statusArchived": "archivé",
    "admin.portfolio.errorLoad": "Échec du chargement des données",
    "admin.portfolio.errorArchive": "Échec de l'archivage du fonds",
    "admin.portfolio.fundArchived": "Fonds archivé",
    "admin.portfolio.fundUpdated": "Fonds mis à jour",
    "admin.portfolio.fundCreated": "Fonds créé",
    "admin.portfolio.errorSave": "Échec de l'enregistrement du fonds",

    // Admin - Charity Management page (GIV-256)
    "admin.charity.title": "Gestion des Organisations",
    "admin.charity.totalCount": "{{count}} au total",
    "admin.charity.allStatuses": "Tous les statuts",
    "admin.charity.searchPlaceholder": "Rechercher par nom\u2026",
    "admin.charity.colName": "Nom",
    "admin.charity.colEin": "ID fiscal",
    "admin.charity.taxIdDisplay": "ID fiscal {{value}}",
    "admin.charity.searchByNameEin": "Rechercher par nom ou ID fiscal…",
    "admin.charity.colCategory": "Catégorie",
    "admin.charity.colStatus": "Statut",
    "admin.charity.colSigner": "Contact",
    "admin.charity.colJoined": "Inscription",
    "admin.charity.colWallet": "Portefeuille",
    "admin.charity.colActions": "Actions",
    "admin.charity.walletNotSet": "Non configuré",
    "admin.charity.approve": "Approuver",
    "admin.charity.reject": "Refuser",
    "admin.charity.suspend": "Suspendre",
    "admin.charity.reinstate": "Réintégrer",
    "admin.charity.statusPending": "En Attente",
    "admin.charity.statusVerified": "Vérifié",
    "admin.charity.statusApproved": "Approuvé",
    "admin.charity.statusRejected": "Refusé",
    "admin.charity.statusSuspended": "Suspendu",
    "admin.charity.approveTitle": "Approuver l'Organisation",
    "admin.charity.rejectTitle": "Refuser l'Organisation",
    "admin.charity.suspendTitle": "Suspendre l'Organisation",
    "admin.charity.reinstateTitle": "Réintégrer l'Organisation",
    "admin.charity.confirmAction": "Confirmer l'Action",
    "admin.charity.reasonRequired": "Raison (requise)",
    "admin.charity.reasonOptional": "Raison (facultatif)",
    "admin.charity.saving": "Enregistrement\u2026",
    "admin.charity.confirm": "Confirmer",
    "admin.charity.noResults":
      "Aucune organisation ne correspond à vos filtres.",
    "admin.charity.unnamed": "Organisation sans nom",

    // Admin - Charity Requests page (GIV-256)
    "admin.charityRequests.title": "Demandes d'Organisations",
    "admin.charityRequests.subtitle":
      "Demandes de donateurs pour des organisations non inscrites, groupées par organisation. Les organisations les plus demandées doivent être contactées en priorité.",
    "admin.charityRequests.ein": "ID fiscal",
    "admin.charityRequests.requests": "Demandes",
    "admin.charityRequests.latestRequester": "Dernier Demandeur",
    "admin.charityRequests.latestRequest": "Dernière Demande",
    "admin.charityRequests.firstRequest": "Première Demande",
    "admin.charityRequests.empty":
      "Aucune demande d'organisation n'a été soumise.",
    "admin.charityRequests.errorTitle": "Erreur de Chargement des Demandes",
    "admin.charityRequests.showing":
      "Affichage de {{shown}} sur {{total}} organisations uniques.",

    // Admin - Volunteer Validation page (GIV-256)
    "admin.validation.title": "Supervision de la Validation Bénévole",
    "admin.validation.totalCount": "{{count}} demandes au total",
    "admin.validation.pipelineStats": "Statistiques du Pipeline",
    "admin.validation.noStats": "Aucune statistique disponible.",
    "admin.validation.pending": "En Attente",
    "admin.validation.approved": "Approuvé",
    "admin.validation.rejected": "Refusé",
    "admin.validation.expired": "Expiré",
    "admin.validation.avgResponseTime": "Temps de réponse moyen :",
    "admin.validation.expirationRate": "Taux d'expiration :",
    "admin.validation.rejectionRate": "Taux de refus :",
    "admin.validation.searchPlaceholder": "Rechercher bénévole, org\u2026",
    "admin.validation.requestsTab": "Demandes de Validation",
    "admin.validation.patternsTab": "Schémas Suspects",
    "admin.validation.colVolunteer": "Bénévole",
    "admin.validation.colOrganisation": "Organisation",
    "admin.validation.colHours": "Heures",
    "admin.validation.colActivityDate": "Date d'Activité",
    "admin.validation.colHrsPerWeek": "Hrs/Semaine",
    "admin.validation.colTotalRequests": "Total des Demandes",
    "admin.validation.override": "Outrepasser",
    "admin.validation.noPatterns": "Aucun schéma suspect détecté.",
    "admin.validation.noRequests": "Aucune demande de validation trouvée.",
    "admin.validation.patternsDescription":
      "Bénévoles signalés pour avoir déclaré plus que le seuil configuré d'heures sur une fenêtre glissante de 7 jours. Ces schémas peuvent indiquer un abus du système d'heures auto-déclarées.",
    "admin.validation.overrideTitle": "Outrepasser la Demande de Validation",
    "admin.validation.newStatus": "Nouveau Statut",
    "admin.validation.reasonRequired": "Raison (requise)",
    "admin.validation.reasonPlaceholder":
      "Expliquez la raison de cette modification\u2026",
    "admin.validation.saving": "Enregistrement\u2026",
    "admin.validation.confirmOverride": "Confirmer la Modification",
    "admin.validation.allStatuses": "Tous les statuts",
    "admin.validation.colStatus": "Statut",
    "admin.validation.colCreated": "Créé",

    // GIV-266: Delta translations (354 keys)
    "home.hero.title": "Générosité Transparente",
    "home.hero.titleAccent": "Impact Durable",
    "home.hero.description":
      "Une philanthropie radicalement transparente pour l'ère numérique. Conçue pour l'impact, soutenue par une technologie vérifiable. Chaque contribution traçable du donateur au bénéficiaire.",
    "home.hero.visionTitle": "Notre Vision",
    "home.hero.visionText":
      "Give Protocol conçoit l'avenir de la générosité à haute intégrité. Nous exploitons une infrastructure technologique avancée pour combler le fossé entre les capitaux mondiaux et l'impact local. En intégrant la prise en charge fluide des actifs numériques aux méthodes de don traditionnelles, nous créons des écosystèmes de financement résilients qui transforment les dons ponctuels en moteurs perpétuels de soutien pour les causes les plus vitales au monde.",
    "home.comingSoon": "Bientôt disponible",
    "home.readDocs": "Lire la Documentation",
    "home.features.sectionTitle":
      "Votre Portail vers une Philanthropie Transparente",
    "home.features.sectionSubtitle":
      "Infrastructure multichaîne pour des dons fluides — crypto ou monnaie fiduciaire — en toute transparence",
    "home.features.highEfficiency.title": "Dons à Haute Efficacité",
    "home.features.highEfficiency.description":
      "Contribuez directement à des organisations vérifiées sans aucune ambiguïté. Notre registre automatisé fournit une vérification en temps réel, garantissant que votre soutien est déployé exactement là où il est le plus nécessaire.",
    "home.features.equityFunds.title": "Fonds d'Équité Caritatifs",
    "home.features.equityFunds.description":
      "Allez au-delà du don ponctuel en contribuant à des fonds d'équité gérés intelligemment. Nous utilisons des stratégies numériques sophistiquées et à faible risque pour transformer votre capital en un flux perpétuel de financement, soutenant les missions caritatives pour les générations à venir.",
    "home.features.impactFunds.title": "Fonds d'Impact",
    "home.features.impactFunds.description":
      "Mutualisez les ressources pour des causes spécifiques. Environnement, éducation, lutte contre la pauvreté — votre don amplifié par l'action collective.",
    "home.features.verifiedOrgs.title": "Organisations Vérifiées",
    "home.features.verifiedOrgs.description":
      "Parcourez toutes les organisations enregistrées, ou recherchez le badge de vérification. Les organisations qui participent à notre processus de vérification obtiennent une certification on-chain à laquelle les donateurs peuvent faire confiance.",
    "home.features.blockchainVerified.title": "Vérification Blockchain",
    "home.features.blockchainVerified.description":
      "Les jetons non transférables (SBT) reconnaissent les contributions bénévoles. Compétences, heures et impact — tout enregistré de manière permanente on-chain.",
    "home.features.bridgingModes.title": "Relier les Modes de Don",
    "home.features.bridgingModes.description":
      "Que vous donniez en USD ou en actifs numériques, notre architecture multi-réseaux garantit que votre contribution circule à la vitesse du monde moderne.",
    "home.roles.title": "Conçu pour Tous Ceux qui Changent le Monde",
    "home.roles.donors.title": "Pour les Donateurs",
    "home.roles.donors.item1":
      "Donnez en crypto ou en monnaie fiduciaire — à vous de choisir",
    "home.roles.donors.item2": "Participation à la gouvernance",
    "home.roles.donors.item3": "Construction de réputation on-chain",
    "home.roles.nonprofits.title": "Pour les Organisations à But Non Lucratif",
    "home.roles.nonprofits.item1":
      "Accédez à de nouvelles catégories de donateurs",
    "home.roles.nonprofits.item2": "Financement durable via les CEF",
    "home.roles.nonprofits.item3": "Rapports de transparence améliorés",
    "home.roles.volunteers.title": "Pour les Bénévoles",
    "home.roles.volunteers.item1": "Registres de contributions vérifiables",
    "home.roles.volunteers.item2":
      "Certifications de compétences portables (SBT)",
    "home.roles.volunteers.item3": "Badges de réussite et reconnaissance",
    "home.impact.title": "Fonds d'Impact Prévus",
    "home.impact.environmental.title": "Fonds d'Impact Environnemental",
    "home.impact.environmental.description":
      "Soutien au reboisement, au nettoyage des océans et aux initiatives d'énergie renouvelable. Des dons mutualisés dirigés vers des organisations environnementales vérifiées ayant un impact mesurable.",
    "home.impact.education.title":
      "Fonds pour l'Égalité des Chances Éducatives",
    "home.impact.education.description":
      "Bourses d'études, outils d'apprentissage numérique et formation des enseignants. Un financement collectif amplifié pour soutenir les initiatives éducatives dans les communautés mal desservies.",
    "home.cta.title": "Prêt à Transformer la Générosité ?",
    "home.cta.subtitle":
      "Soyez parmi les premiers à découvrir une philanthropie transparente, propulsée par la blockchain. Rejoignez notre communauté qui bâtit un avenir meilleur pour les dons caritatifs.",
    "home.cta.explore": "Explorer les Causes",
    "home.nav.features": "Fonctionnalités",
    "home.nav.impact": "Impact",
    "home.nav.charities": "Organisations",
    "home.nav.volunteer": "Bénévolat",
    "home.footer.brand.tagline":
      "Transformer la philanthropie grâce à la transparence blockchain et au financement durable.",
    "home.footer.product.title": "Produit",
    "home.footer.product.impactFunds": "Fonds d'Impact",
    "home.footer.product.charities": "Pour les Organisations",
    "home.footer.product.volunteers": "Pour les Bénévoles",
    "home.footer.resources.title": "Ressources",
    "home.footer.resources.whitepaper": "Livre Blanc (Bientôt disponible)",
    "home.footer.resources.blog": "Blog (Bientôt disponible)",
    "home.footer.resources.community": "Communauté (Bientôt disponible)",
    "home.footer.connect.title": "Contact",
    "home.footer.connect.contact": "Contact (Bientôt disponible)",
    "home.footer.copyright":
      "Give Protocol. Multichaîne par conception. Propulsé par les bénévoles de Give Protocol.",
    "auth.signin.welcomeBack": "Bienvenue",
    "auth.signin.subtitle": "Connectez-vous à votre compte Give Protocol",
    "auth.signin.emailPlaceholder": "E-mail",
    "auth.signin.passwordPlaceholder": "Mot de passe",
    "auth.signin.submitting": "Connexion en cours…",
    "auth.signin.withPasskey": "Se connecter avec une Passkey",
    "auth.signin.withGoogle": "Continuer avec Google",
    "auth.signin.or": "ou",
    "auth.signin.newToProtocol": "Nouveau sur Give Protocol ?",
    "auth.signin.createAccount": "Créer un compte →",
    "auth.signin.forgotPasswordLink": "Mot de passe oublié ? →",
    "auth.signin.sslEncrypted": "Chiffrement TLS",
    "auth.signin.modeToggleLabel": "Méthode de connexion",
    "auth.signin.terms": "Conditions",
    "auth.signin.privacy": "Confidentialité",
    "auth.panel.headline": "Dons intelligents, impact transparent.",
    "auth.panel.subheadline":
      "Un seul compte. Donnez par carte ou crypto. Suivez chaque centime on-chain.",
    "auth.panel.statusLabel": "Statut du Protocole · Phase de Genèse",
    "auth.panel.statusDesc":
      "Construire les fondations d'une générosité transparente",
    "auth.panel.runsOn": "Fonctionne sur",
    "auth.wallet.connect": "Connecter le Portefeuille",
    "auth.wallet.connecting": "Connexion au portefeuille…",
    "auth.wallet.signing": "Signature du message…",
    "auth.wallet.verifying": "Vérification…",
    "auth.wallet.openingSession": "Ouverture de la session…",
    "auth.validation.emailRequired":
      "Veuillez d'abord saisir votre adresse e-mail",
    "auth.validation.invalidEmail": "Veuillez saisir une adresse e-mail valide",
    "auth.validation.passwordTooShort":
      "Le mot de passe doit contenir au moins 8 caractères",
    "auth.validation.passwordMismatch":
      "Les mots de passe ne correspondent pas",
    "auth.login.welcomeHeading": "Bienvenue sur Give Protocol",
    "auth.login.signInOrConnect": "Connexion ou Liaison",
    "auth.login.skipToContent": "Accéder directement au contenu de connexion",
    "auth.login.donorTitle": "Connexion Donateur",
    "auth.login.donorSubtitle":
      "Connectez-vous pour accéder à votre tableau de bord de dons",
    "auth.login.charityTitle": "Portail Organisation",
    "auth.login.charitySubtitle":
      "Gérez le profil de votre organisation et vos dons",
    "auth.login.back": "← Retour",
    "auth.login.continueDonor": "Continuer en tant que Donateur",
    "auth.login.connecting": "Connexion…",
    "auth.login.connectWalletSignIn":
      "Connecter le Portefeuille et Se Connecter",
    "auth.login.newToPlatform": "Nouveau sur Give Protocol ?",
    "auth.login.newDonorSignUp": "Inscription Nouveau Donateur",
    "auth.login.manageNonprofit": "Je gère un profil d'Organisation",
    "auth.login.nonprofitTrayTitle": "Nouveau sur Give Protocol ?",
    "auth.login.createNonprofitAccount": "Créer un Compte Organisation",
    "auth.login.registerOrg":
      "Enregistrez votre organisation sur Give Protocol",
    "auth.login.needHelp": "Besoin d'aide ?",
    "auth.login.forgotUsernameBtn": "Nom d'utilisateur oublié ?",
    "auth.login.forgotPasswordBtn": "Mot de passe oublié ?",
    "auth.donorLogin.mismatch":
      "Compte Donateur Introuvable. Cet e-mail est enregistré en tant que compte d'organisation. Veuillez utiliser la connexion Organisation.",
    "auth.donorLogin.signingIn": "Connexion en cours…",
    "auth.donorLogin.redirecting": "Redirection dans {{count}}...",
    "auth.donorReg.pleaseWait": "Veuillez patienter…",
    "auth.donorReg.signUpPasskey": "S'inscrire avec une Passkey",
    "auth.donorReg.withGoogle": "Continuer avec Google",
    "auth.donorReg.connectWallet": "Connecter le Portefeuille",
    "auth.donorReg.orSetPassword": "Ou définir un mot de passe",
    "auth.donorReg.creating": "Création du Compte...",
    "auth.donorReg.createAccount": "Créer un Compte Donateur",
    "auth.donorReg.privacyNotice": "En créant un compte, vous acceptez nos",
    "auth.donorReg.termsLink": "Conditions de Service",
    "auth.donorReg.privacyAnd": "et reconnaissez notre",
    "auth.donorReg.privacyLink": "Politique de Confidentialité",
    "auth.charityLogin.mismatch":
      "Cet e-mail est enregistré en tant que compte donateur. Veuillez vous connecter via le portail donateur.",
    "auth.charityLogin.signingIn": "Connexion en cours...",
    "auth.charityLogin.or": "ou",
    "auth.charityLogin.connecting": "Connexion...",
    "auth.charityLogin.connectWallet": "Connecter le Portefeuille",
    "auth.forgot.resetPassword": "Réinitialiser le Mot de Passe",
    "auth.forgot.forgotUsername": "Nom d'Utilisateur Oublié",
    "auth.forgot.passwordDesc":
      "Saisissez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    "auth.forgot.usernameDesc":
      "Saisissez votre adresse e-mail et nous vous enverrons votre nom d'utilisateur.",
    "auth.forgot.passwordSuccess":
      "Les instructions de réinitialisation du mot de passe ont été envoyées à votre adresse e-mail",
    "auth.forgot.usernameSuccess":
      "Un rappel de votre nom d'utilisateur a été envoyé à votre adresse e-mail",
    "auth.forgot.checkEmail": "Consultez votre e-mail",
    "auth.forgot.backToSignIn": "Retour à la Connexion",
    "auth.forgot.emailPlaceholder": "Saisissez votre adresse e-mail",
    "auth.forgot.genericError": "Une erreur est survenue. Veuillez réessayer.",
    "auth.forgot.sending": "Envoi en cours...",
    "auth.forgot.sendResetLink": "Envoyer le Lien de Réinitialisation",
    "auth.forgot.sendUsername": "Envoyer le Nom d'Utilisateur",

    // Reset password (set new password page) — pending translation (GIV-367)
    "auth.resetPassword.title": "Set New Password",
    "auth.resetPassword.subtitle": "Choose a strong password for your account.",
    "auth.resetPassword.newPassword": "New Password",
    "auth.resetPassword.confirmPassword": "Confirm New Password",
    "auth.resetPassword.submit": "Update Password",
    "auth.resetPassword.updating": "Updating\u2026",
    "auth.resetPassword.mismatch": "Passwords do not match.",
    "auth.resetPassword.success": "Password updated successfully!",
    "auth.resetPassword.successSubtitle":
      "You can now sign in with your new password.",
    "auth.resetPassword.backToSignIn": "Back to Sign In",
    "auth.resetPassword.invalidLink":
      "This password reset link is invalid or has expired.",
    "auth.resetPassword.requestNew": "Request a new reset link",
    "auth.resetPassword.validating": "Validating reset link\u2026",
    "auth.orgSearch.orgNameLabel": "Nom de l'Organisation",
    "auth.orgSearch.searchPlaceholder": "Rechercher par nom d'organisation...",
    "auth.orgSearch.countryLabel": "Pays",
    "auth.orgSearch.allCountries": "Tous les Pays",
    "auth.orgSearch.searchPrompt":
      "Recherchez dans notre base de données pour trouver et revendiquer votre organisation.",
    "auth.orgSearch.noResults": "Aucune organisation trouvée.",
    "auth.orgSearch.loadMore": "Charger plus de résultats",
    "auth.orgSearch.cantFind": "Vous ne trouvez pas votre organisation ?",
    "auth.orgSearch.registerManually": "Inscription manuelle",
    "charity.claim.orgDetails":
      "Détails de l'Organisation (depuis le registre)",
    "charity.claim.orgNameLabel": "Nom",
    "charity.claim.einLabel": "ID fiscal",
    "charity.claim.locationLabel": "Localisation",
    "charity.claim.contactInfo": "Informations de Contact",
    "charity.claim.contactName": "Nom du Contact",
    "charity.claim.contactEmail": "E-mail de Contact",
    "charity.claim.accountSecurity": "Sécurité du Compte",
    "charity.claim.password": "Mot de passe",
    "charity.claim.confirmPassword": "Confirmer le Mot de Passe",
    "charity.claim.backToSearch": "Retour à la recherche",
    "charity.claim.creating": "Création du Compte...",
    "charity.claim.submit": "Revendiquer l'Organisation",
    "charity.claim.validation.name":
      "Le nom doit contenir entre 2 et 100 caractères",
    "charity.claim.validation.email":
      "Veuillez saisir une adresse e-mail valide",
    "charity.claim.validation.password":
      "Le mot de passe doit contenir au moins 8 caractères",
    "charity.claim.validation.confirmPassword":
      "Les mots de passe ne correspondent pas",
    "charity.claim.validation.fix":
      "Veuillez corriger les erreurs de validation",
    "charity.claim.useAsPublicEmail":
      "Utiliser mon e-mail comme e-mail de contact public de l'organisation",
    "charity.claim.publicContactEmail":
      "E-mail de contact public de l'organisation",
    "charity.claim.privacyNotice":
      "Votre e-mail/téléphone personnel de signataire est utilisé uniquement pour la vérification et n'est pas visible par les autres utilisateurs de la plateforme. L'e-mail de contact public est affiché sur le profil de votre organisation.",
    "charity.claim.secondContactTitle": "Deuxième Contact",
    "charity.claim.secondContactName": "Nom du deuxième contact",
    "charity.claim.secondContactEmail": "E-mail du deuxième contact",
    "charity.claim.secondContactHint":
      "Une personne différente, notifiée lorsque le portefeuille ou les informations de paiement de votre association changent.",
    "charity.claim.validation.secondEmailDistinct":
      "L'e-mail du deuxième contact doit être différent de l'e-mail principal",
    "charity.claim.error.creation": "La création du compte a échoué",
    "charity.claim.error.generic": "Impossible de créer le compte",
    "charity.vetting.orgDetails": "Détails de l'Organisation",
    "charity.vetting.orgName": "Nom de l'Organisation",
    "charity.vetting.description": "Description",
    "charity.vetting.taxId": "Numéro Fiscal ou d'Enregistrement",
    "charity.vetting.countryLabel": "Pays",
    "charity.vetting.selectCountry": "Sélectionner un Pays",
    "charity.vetting.address": "Adresse",
    "charity.vetting.streetAddress": "Adresse Postale",
    "charity.vetting.city": "Ville",
    "charity.vetting.state": "État/Province",
    "charity.vetting.postalCode": "Code Postal",
    "charity.vetting.contactInfo": "Informations de Contact",
    "charity.vetting.contactName": "Nom du Contact",
    "charity.vetting.contactEmail": "E-mail de Contact",
    "charity.vetting.accountSecurity": "Sécurité du Compte",
    "charity.vetting.password": "Mot de passe",
    "charity.vetting.confirmPassword": "Confirmer le Mot de Passe",
    "charity.vetting.submitting": "Envoi de la Candidature...",
    "charity.vetting.submit": "Soumettre la Candidature Caritative",
    "charity.vetting.validation.orgName":
      "Le nom de l'organisation doit contenir entre 2 et 100 caractères",
    "charity.vetting.validation.contactName":
      "Le nom du contact doit contenir entre 2 et 100 caractères",
    "charity.vetting.validation.email":
      "Veuillez saisir une adresse e-mail valide",
    "charity.vetting.validation.password":
      "Le mot de passe doit contenir au moins 8 caractères",
    "charity.vetting.validation.confirmPassword":
      "Les mots de passe ne correspondent pas",
    "charity.vetting.validation.description": "La description est requise",
    "charity.vetting.validation.category": "La catégorie est requise",
    "charity.vetting.validation.taxId": "Le numéro fiscal est requis",
    "charity.vetting.validation.streetAddress": "L'adresse postale est requise",
    "charity.vetting.validation.city": "La ville est requise",
    "charity.vetting.validation.country": "Le pays est requis",
    "charity.vetting.validation.fix":
      "Veuillez corriger les erreurs de validation",
    "charity.vetting.error.generic": "Impossible de soumettre la candidature",
    "charity.vetting.privacyNotice":
      "En soumettant cette candidature, vous acceptez nos",
    "charity.vetting.termsLink": "Conditions de Service",
    "charity.vetting.privacyAnd": "et reconnaissez notre",
    "charity.vetting.privacyLink": "Politique de Confidentialité",
    "common.email": "E-mail",
    "common.password": "Mot de passe",
    "common.confirmPassword": "Confirmer le Mot de Passe",
    "footer.brand.tagline":
      "Supprimer les obstacles à la générosité caritative durable.",
    "footer.resources.title": "Ressources",
    "footer.resources.faq": "FAQ",
    "footer.resources.about": "À Propos",
    "footer.legal.title": "Mentions Légales",
    "footer.legal.terms": "Conditions d'Utilisation",
    "footer.legal.privacy": "Politique de Confidentialité",
    "footer.legal.cookiePreferences": "Préférences de cookies",
    "consent.banner.ariaLabel": "Consentement aux cookies",
    "consent.banner.body":
      "Nous utilisons Google Analytics 4 (Google LLC, États-Unis) et Sentry (Functional Software, États-Unis/UE) pour comprendre comment l'application est utilisée et détecter les erreurs. Aucune adresse e-mail, adresse de portefeuille ou nom de donateur n'est partagé. Vous pouvez retirer votre consentement à tout moment.",
    "consent.banner.privacyLink": "Politique de confidentialité",
    "consent.banner.acceptAll": "Tout accepter",
    "consent.banner.decline": "Refuser les non essentiels",
    "consent.banner.customize": "Personnaliser",
    "consent.modal.title": "Préférences de cookies",
    "consent.modal.essentialTitle": "Essentiels",
    "consent.modal.essentialDesc":
      "Nécessaires au fonctionnement de base du site, comme la navigation et l'authentification. Ne peuvent pas être désactivés.",
    "consent.modal.essentialAlwaysOn": "Cookies essentiels — toujours actifs",
    "consent.modal.analyticsTitle":
      "Analyse (Google Analytics 4 · États-Unis, Sentry · États-Unis/UE)",
    "consent.modal.analyticsDesc":
      "Les cookies d'analyse nous aident à comprendre quelles pages sont visitées et comment les utilisateurs naviguent dans l'application. Nous utilisons Google Analytics 4 \u2014 identifiants de session, URL des pages, métadonnées appareil/navigateur, localisation approximative à partir d'IP anonymisée (Google LLC, États-Unis ; SCCs + EU\u2013US Data Privacy Framework). Sentry \u2014 traces d'erreurs anonymisées et métadonnées du navigateur pour la surveillance de fiabilité (Functional Software, UE/États-Unis ; mécanisme de transfert en attente). Aucune adresse e-mail, adresse de portefeuille ou nom de donateur n'est partagé avec les sous-traitants.",
    "consent.modal.analyticsOn": "Analyse et enregistrement d'erreurs — activé",
    "consent.modal.analyticsOff":
      "Analyse et enregistrement d'erreurs — désactivé",
    "consent.modal.cancel": "Annuler",
    "consent.modal.save": "Enregistrer les préférences",
    "footer.connect.title": "Contact",
    "footer.copyright": "Give Protocol. Tous droits réservés.",
    "nav.signIn": "Connexion",
    "nav.signOut": "Déconnexion",
    "nav.privacy": "Confidentialité",
    "auth.signup.heading": "Créez votre compte",
    "auth.signup.subtitle":
      "Rejoignez le mouvement pour une générosité transparente",
    "auth.signup.displayName": "Nom d'affichage",
    "auth.signup.emailPlaceholder": "E-mail",
    "auth.signup.passwordPlaceholder": "Mot de passe",
    "auth.signup.confirmPasswordPlaceholder": "Confirmer le mot de passe",
    "auth.signup.submit": "Créer un Compte",
    "auth.signup.submitting": "Création du compte…",
    "auth.signup.withPasskey": "S'inscrire avec une Passkey",
    "auth.signup.withGoogle": "Continuer avec Google",
    "auth.signup.connectWallet": "Connecter le Portefeuille",
    "auth.signup.orSetPassword": "Ou définir un mot de passe",
    "auth.signup.alreadyHaveAccount": "Vous avez déjà un compte ?",
    "auth.signup.signInLink": "Se connecter",
    "auth.signup.manageNonprofit": "Vous gérez une organisation ?",
    "auth.signup.trustText": "Vos données sont protégées par",
    "auth.signup.and": "et",
    "auth.signup.privacyPolicy": "Politique de Confidentialité",
    "auth.signup.panel.headline": "Des dons que vous pouvez vérifier.",
    "browse.hero.title": "Des dons, vérifiés on-chain.",
    "browse.hero.subtitle":
      "Découvrez des causes vérifiées, contribuez par carte ou actifs numériques et voyez l'empreinte tangible de votre temps et de vos ressources.",
    "browse.stats.networks": "Réseaux supportés",
    "browse.stats.sectors": "Secteurs caritatifs",
    "browse.stats.verifiedOrgs": "Organisations vérifiées",
    "browse.stats.volunteerHours": "Heures de bénévolat",
    "browse.verified": "Vérifié",
    "browse.donate": "Donner",
    "browse.viewProfile": "Voir le profil",
    "browse.filter.ariaLabel": "Filtrer les organisations",
    "browse.filter.searchAria": "Rechercher des organisations",
    "browse.filter.locationAria": "Rechercher un lieu",
    "browse.results.ariaLabel": "Résultats des organisations",
    "browse.tabs.charities": "Organisations",
    "browse.tabs.causes": "Causes",
    "browse.tabs.funds": "Fonds de Portefeuille",
    "browse.tabs.ariaLabel": "Parcourir les catégories",
    "browse.featured.heading": "Organisations en vedette",
    "browse.featured.ariaLabel": "Organisations en vedette",
    "browse.featured.nextAria": "Organisations en vedette suivantes",
    "browse.causes.heading": "Causes en vedette",
    "browse.causes.ariaLabel": "Causes en vedette",
    "browse.causes.badge": "Cause",
    "browse.causes.raised": "collectés",
    "browse.causes.percentOf": "% de",
    "browse.causes.by": "par",
    "browse.causes.supportCta": "Soutenir Cette Cause",
    "browse.causes.giveCta": "Donner",
    "browse.causes.nextAria": "Causes en vedette suivantes",
    "browse.funds.heading": "Fonds de Portefeuille",
    "browse.funds.ariaLabel": "Fonds de Portefeuille",
    "browse.funds.badge": "Fonds de Portefeuille",
    "browse.funds.charity": "organisation",
    "browse.funds.charities": "organisations",
    "browse.funds.donateCta": "Donner au Fonds",
    "browse.funds.nextAria": "Fonds de portefeuille suivants",
    "portfolio.notFound.title": "Fonds de portefeuille introuvable",
    "portfolio.notFound.body":
      "Le fonds de portefeuille que vous recherchez n’existe pas ou n’est plus actif.",
    "portfolio.supportedOrgs": "Organisations soutenues",
    "browse.charity.einLabel": "ID fiscal",
    "browse.charity.einDisplay": "ID fiscal : {{value}}",
    "browse.charity.nteeLabel": "Code de secteur",
    "browse.charity.deductibilityLabel": "Déductibilité",
    "browse.charity.onPlatform": "Sur la Plateforme",
    "browse.charity.loading": "Chargement…",
    "browse.charity.loadMore": "Charger Plus",
    "browse.filter.searchPlaceholder": "Rechercher des associations...",
    "browse.filter.locationPlaceholder": "Ville, région ou pays...",
    "browse.whyGiveProtocol.heading": "Pourquoi Give Protocol ?",
    "browse.whyGiveProtocol.verified.title": "Associations vérifiées",
    "browse.whyGiveProtocol.verified.description":
      "Chaque organisation est vérifiée dans les registres publics avant d'apparaître sur la plateforme.",
    "browse.whyGiveProtocol.onchain.title": "Transparence on-chain",
    "browse.whyGiveProtocol.onchain.description":
      "Les dons sont enregistrés sur la blockchain pour que vous puissiez suivre votre impact du portefeuille à la cause.",
    "browse.whyGiveProtocol.volunteer.title":
      "Donnez du temps, pas seulement de l'argent",
    "browse.whyGiveProtocol.volunteer.description":
      "Les heures de bénévolat sont vérifiées par les associations et comptent dans votre réputation sur le protocole.",
    "browse.news.heading": "Actualités de la Plateforme",
    "admin.news.deleteConfirmBody": "« {{title}} » sera définitivement supprimé. Cette action est irréversible.",
    "admin.news.deleteConfirmTitle": "Supprimer l'actualité ?",
    "admin.news.saveFailed": "Impossible d'enregistrer vos modifications. Veuillez réessayer.",
    "admin.news.urlHelp": "Facultatif. Laissez vide pour afficher l'actualité sans lien.",
    "admin.news.urlInvalid": "Saisissez une adresse https:// complète ou un chemin commençant par /.",
    "browse.carousel.error": "Impossible de charger cette section. Veuillez actualiser la page et réessayer.",
    "browse.carousel.goToPage": "Aller à la page {{page}}",
    "browse.carousel.pageLabel": "Page {{current}} sur {{total}}",
    "browse.carousel.pause": "Mettre en pause la rotation automatique",
    "browse.carousel.play": "Reprendre la rotation automatique",
    "browse.causes.empty": "Aucune cause disponible pour le moment. Revenez bientôt !",
    "browse.causes.prevAria": "Causes en vedette précédentes",
    "browse.causes.searchPlaceholder": "Rechercher des causes...",
    "browse.causes.subheading": "Soutenez des projets concrets qui ont un impact réel.",
    "browse.charity.registryIdDisplay": "Identifiant de registre : {{value}}",
    "browse.featured.empty": "Aucune organisation en vedette pour le moment. Utilisez la recherche ci-dessus pour trouver une association.",
    "browse.featured.prevAria": "Organisations en vedette précédentes",
    "browse.featured.subheading": "Un aperçu tournant des associations vérifiées sur Give Protocol.",
    "browse.filter.addLocation": "Ajouter un lieu",
    "browse.filter.impactNotice": "Le filtrage par lieu d'impact n'est pas encore disponible ; les résultats ne sont donc pas restreints par lieu d'impact.",
    "browse.filter.locationHint": "Appuyez sur Entrée ou choisissez Ajouter pour appliquer un lieu.",
    "browse.filter.minChars": "Saisissez au moins 2 caractères pour lancer la recherche.",
    "browse.funds.empty": "Aucun fonds de portefeuille disponible pour le moment. Revenez bientôt !",
    "browse.funds.prevAria": "Fonds de portefeuille précédents",
    "browse.funds.searchPlaceholder": "Rechercher des fonds de portefeuille...",
    "browse.funds.subheading": "Portefeuilles de dons sélectionnés qui répartissent les dons entre des associations vérifiées.",
    "browse.registry.badge": "Enregistrée auprès de {{registry}}",
    "browse.results.empty": "Aucune organisation ne correspond à cette recherche. Essayez un autre mot-clé ou ajoutez un filtre de lieu.",
    "browse.results.error": "Impossible d'effectuer cette recherche. Veuillez réessayer.",
    "browse.search.noMatches": "Aucun résultat pour « {{query}} ».",
    "browse.category.A": "Arts et culture",
    "browse.category.B": "Éducation",
    "browse.category.C": "Environnement",
    "browse.category.D": "Protection animale",
    "browse.category.E": "Santé",
    "browse.category.F": "Santé mentale",
    "browse.category.G": "Recherche médicale",
    "browse.category.H": "Recherche biomédicale",
    "browse.category.I": "Justice et criminalité",
    "browse.category.J": "Emploi",
    "browse.category.K": "Alimentation et nutrition",
    "browse.category.L": "Logement",
    "browse.category.M": "Sécurité publique",
    "browse.category.N": "Loisirs",
    "browse.category.O": "Développement de la jeunesse",
    "browse.category.P": "Services sociaux",
    "browse.category.Q": "International",
    "browse.category.R": "Droits civiques",
    "browse.category.S": "Développement communautaire",
    "browse.category.T": "Philanthropie",
    "browse.category.U": "Science et technologie",
    "browse.category.V": "Sciences sociales",
    "browse.category.W": "Politiques publiques",
    "browse.category.X": "Religion",
    "browse.category.Y": "Bénéfice mutuel",
    "browse.category.default": "Organisation à but non lucratif",
    "cause.causes": "Causes",
    "cause.createNew": "Créer",
    "cause.noCausesTitle": "Aucune cause pour le moment",
    "cause.name": "Nom",
    "cause.description": "Description",
    "cause.category": "Catégorie",
    "cause.targetAmount": "Montant Cible",
    "cause.headerImage": "Image d'En-tête",
    "cause.impact": "Impact",
    "cause.impactHelp": "Décrivez l'impact attendu de cette cause.",
    "cause.location": "Localisation",
    "cause.timeline": "Calendrier",
    "cause.partners": "Partenaires",
    "cause.limitReached": "Limite de causes atteinte",
    "impact.statistics": "Statistiques d'Impact",
    "impact.statLabel": "Libellé",
    "impact.statValue": "Valeur",
    "impact.missionStatement": "Déclaration de Mission",
    "impact.missionPlaceholder": "Notre mission est de...",
    "impact.highlights": "Points Forts de l'Impact",
    "impact.highlight": "Point fort de l'impact",
    "impact.addHighlight": "Ajouter un Point Fort",
    "impact.profile": "Profil d'Impact",
    "impact.loadError": "Impossible de charger le profil d'impact",
    "impact.saveError": "Impossible d'enregistrer le profil d'impact",
    "impact.saveSuccess": "Profil d'impact enregistré avec succès",
    "organization.yearFounded": "Année de Fondation",
    "organization.address": "Adresse",
    "organization.street": "Adresse Postale",
    "organization.city": "Ville",
    "organization.stateProvince": "État/Province",
    "organization.postalCode": "Code Postal",
    "organization.country": "Pays",
    "organization.contactInfo": "Informations de Contact",
    "organization.phone": "Téléphone",
    "organization.email": "E-mail",
    "organization.website": "Site Web",
    "organization.socialMedia": "Réseaux Sociaux",
    "organization.publicFeed": "Fil Public",
    "organization.communityMedia": "Communauté et Médias",
    "organization.profile": "Profil de l'Organisation",
    "organization.loadError":
      "Impossible de charger le profil de l'organisation",
    "organization.saveError":
      "Impossible d'enregistrer le profil de l'organisation",
    "common.remove": "Supprimer",
    "common.saveChanges": "Enregistrer les Modifications",
    "dashboard.thisMonth": "Ce mois-ci",
    "dashboard.verified": "Bénévoles vérifiés",
    "dashboard.hoursLogged": "Heures enregistrées",
    "dashboard.endorsements": "Recommandations",
    "dashboard.organizationsHelped": "Organisations Aidées",
    "dashboard.yourOrganizationsHelped": "Vos Organisations Aidées",
    "transactions.createCampaign": "Créer votre première campagne",
    "contributions.emptyTitle": "Votre parcours de générosité commence ici",
    "contributions.browseCharities": "Parcourir les organisations",
    "charity.profile.verified501c3": "Organisme à but non lucratif vérifié",
    "charity.profile.verified501c3Tooltip":
      "Organisation 501(c)(3) enregistrée — les dons peuvent être déductibles des impôts aux États-Unis",
    "charity.profile.statusClaimed": "Revendiqué",
    "charity.profile.statusUnclaimed":
      "Non revendiqué — données du registre public uniquement",
    "charity.profile.statusIrsVerified":
      "Organisme à but non lucratif vérifié par l'IRS",
    "charity.profile.requestWidget.unclaimedBody":
      "Cette organisation n'a pas encore revendiqué son profil sur Give Protocol. Les dons seront disponibles une fois que l'organisation aura revendiqué son profil et terminé la configuration de son portefeuille.",
    "charity.profile.rowEin": "ID fiscal",
    "charity.profile.rowName": "Nom",
    "charity.profile.rowLocation": "Localisation",
    "charity.profile.rowRulingYear": "Année d'enregistrement",
    "charity.profile.rowNteeCode": "Code de secteur",
    "charity.profile.rowDeductibility": "Déductibilité",
    "charity.profile.rowAffiliation": "Affiliation",
    "charity.profile.rowClassification": "Classification",
    "charity.profile.rowFoundation": "Type de fondation",
    "charity.profile.rowActivityCodes": "Codes d'activité",
    "charity.profile.rowOrgType": "Type d'organisation",
    "charity.profile.rowSubsection": "Sous-section",
    "charity.profile.rowStatus": "Statut",
    "charity.profile.registryRecord": "Registre Public",
    "charity.profile.einDisplay": "ID fiscal",
    "charity.profile.charityNotFoundByTaxId":
      "Nous n'avons pas trouvé d'organisme avec cet ID fiscal.",
    "charity.profile.registeredNonprofit":
      "Organisme à but non lucratif enregistré",
    "charity.profile.registeredYear": "Enregistré en {{year}}",
    "charity.profile.shareAria": "Partager",
    "charity.profile.copied": "Copié !",
    "charity.profile.about": "À Propos",
    "charity.profile.claimProfile": "Revendiquer ce profil",
    "charity.profile.noDescription": "Aucune description disponible.",
    "charity.profile.toAddOne": "pour en ajouter une.",
    "charity.profile.contact": "Contact",
    "charity.profile.donate.support": "Soutenir",
    "charity.profile.donate.walletUnset":
      "Cette organisation n'a pas encore configuré de portefeuille officiel.",
    "charity.profile.donate.walletPending":
      "Cette organisation finalise la configuration de son portefeuille — les dons sont temporairement indisponibles.",
    "charity.profile.donate.walletLegacy":
      "Cette organisation utilise une adresse de portefeuille héritée.",
    "charity.profile.donate.feeNote":
      "0% de frais de plateforme sur les dons directs. Des frais de réseau s'appliquent.",
    "charity.profile.donate.jurisdictionUnavailable":
      "Les dons aux organisations caritatives en dehors des États-Unis ne sont pas encore disponibles sur Give Protocol.",
    "portfolio.title": "Fonds de Portefeuille",
    "settings.displayPreferences": "Préférences d'affichage",
    "settings.theme": "Thème",
    "settings.light": "Clair",
    "settings.dark": "Sombre",
    "auth.toast.welcomeBack": "Welcome back, {{firstName}}",
    "auth.toast.youreSignedIn": "You're signed in.",
    "auth.toast.walletConnected": "Wallet connected",
    "auth.toast.signedInWith": "Signed in with {{address}}.",
    "auth.toast.signedOut": "Signed out",
    "auth.toast.signInFailed": "Sign-in failed",
    "auth.toast.signOutFailed": "Sign-out failed",
    "donation.toast.received": "Donation received",
    "donation.toast.receivedMessage":
      "Thank you — your tax receipt is on the way.",
    "donation.toast.submitted": "Transaction submitted",
    "donation.toast.submittedMessage": "Waiting for on-chain confirmation…",
    "donation.toast.confirmed": "Donation confirmed",
    "donation.toast.confirmedMessage":
      "Your contribution is recorded on-chain.",
    "donation.toast.failed": "Donation failed",

    // Art. 9(2)(a) donation consent (GIV-655)
    "donation.art9Consent.statement":
      "Je comprends que mon enregistrement de don me lie à {{charity}}. Dans la mesure où cela pourrait indiquer une affiliation religieuse, politique ou philosophique, je consens expressément à ce que Give Protocol traite cet enregistrement afin de compléter et d'administrer mon don.",
    "donation.art9Consent.label": "Consentement relatif aux données de don",
    "donation.art9Consent.required":
      "Vous devez consentir au traitement des données de don pour continuer.",

    "charity.toast.verificationEmailSent": "Verification email sent",
    "charity.toast.verificationEmailMessage":
      "Check your inbox — the link expires in 24 hours.",
    "charity.toast.submissionFailed": "Submission failed",

    "privacy.security.auditLog":
      "En tant que mesure technique au titre de l'article 32 du RGPD, nous enregistrons et surveillons les accès administratifs aux données personnelles — y compris l'action effectuée et le moment où elle a eu lieu — afin de détecter les accès non autorisés, de démontrer la responsabilité et de reconstituer les événements dans le cas improbable d'une violation de données personnelles (article 34). Les données personnelles des donateurs ne sont pas dupliquées dans ces journaux d'accès administratif. Les journaux d'accès administratif sont distincts des journaux d'authentification et de sécurité décrits au §7.1 ; leur durée de conservation est régie par notre Registre des activités de traitement interne.",

    // Remaining i18n keys — batch translation
    "admin.auditTrail.filterByAction": "Filtrer par action",
    "admin.auditTrail.allActions": "Toutes les actions",
    "admin.auditTrail.action.charityStatusChange":
      "Changement de statut d'association",
    "admin.auditTrail.action.userStatusChange":
      "Changement de statut d'utilisateur",
    "admin.auditTrail.action.donationFlag": "Signalement de don",
    "admin.auditTrail.action.donationFlagResolve":
      "Résolution de signalement de don",
    "admin.auditTrail.action.validationOverride": "Dérogation de validation",
    "admin.auditTrail.action.configChange": "Changement de configuration",
    "admin.auditTrail.action.verificationApprove":
      "Approbation de vérification",
    "admin.auditTrail.action.verificationReject": "Rejet de vérification",
    "admin.auditTrail.action.charitySuspend": "Suspension d'association",
    "admin.auditTrail.action.charityReinstate": "Réintégration d'association",
    "admin.auditTrail.action.userSuspend": "Suspension d'utilisateur",
    "admin.auditTrail.action.userReinstate": "Réintégration d'utilisateur",
    "admin.auditTrail.action.userBan": "Bannissement d'utilisateur",
    "admin.auditTrail.action.viewPii":
      "Consultation de données personnelles (PII)",
    "admin.auditTrail.action.viewPiiList":
      "Consultation de la liste des données personnelles (PII)",
    "admin.auditTrail.viewedEntity":
      "L'administrateur {{adminId}} a consulté {{entityType}} {{entityId}}",
    "admin.auditTrail.viewedList":
      "L'administrateur {{adminId}} a consulté la liste {{entityType}} (page {{page}}, filtres : {{filters}})",
    "admin.auditTrail.viewedListNoFilters":
      "L'administrateur {{adminId}} a consulté la liste {{entityType}} (page {{page}})",
    "admin.actions.platformNews": "Actualités de la plateforme",
    "admin.actions.platformNewsDesc":
      "Gérer les actualités affichées sur la page de découverte",
    "admin.news.activate": "Activer {{title}}",
    "admin.news.activated": "Actualité publiée",
    "admin.news.activeLabel": "Publiée (visible du public)",
    "admin.news.categoryLabel": "Catégorie",
    "admin.news.contentLabel": "Contenu / Extrait",
    "admin.news.contentPlaceholder": "Brève description de l'actualité...",
    "admin.news.createNews": "Créer une actualité",
    "admin.news.createNewsBtn": "Créer l'actualité",
    "admin.news.created": "Actualité créée",
    "admin.news.dateLabel": "Date de publication",
    "admin.news.deactivate": "Désactiver {{title}}",
    "admin.news.deactivated": "Actualité masquée",
    "admin.news.deleteItem": "Supprimer {{title}}",
    "admin.news.deleted": "Actualité supprimée",
    "admin.news.editItem": "Modifier {{title}}",
    "admin.news.editNews": "Modifier l'actualité",
    "admin.news.imageLabel": "URL de l'image (facultatif)",
    "admin.news.imagePlaceholder": "https://...",
    "admin.news.inactive": "Inactive",
    "admin.news.newItem": "Nouvelle actualité",
    "admin.news.noItemsMessage":
      "Créez votre première actualité pour partager des mises à jour avec votre communauté",
    "admin.news.noItemsYet": "Aucune actualité pour le moment",
    "admin.news.publishedOn": "Publiée le {{date}}",
    "admin.news.saving": "Enregistrement...",
    "admin.news.subtitle":
      "Gérer les actualités affichées sur la page de découverte publique",
    "admin.news.title": "Actualités de la plateforme",
    "admin.news.titleLabel": "Titre",
    "admin.news.titlePlaceholder": "ex. Rapport d'impact trimestriel",
    "admin.news.updateNews": "Mettre à jour l'actualité",
    "admin.news.updated": "Actualité mise à jour",
    "admin.news.urlLabel": "URL du lien",
    "admin.news.urlPlaceholder": "https://example.org/article",
    "charity.walletBadge.institutionalLabel": "Détenu chez {{custodianName}}",
    "charity.walletBadge.institutionalTooltip":
      "Les dons sont versés à un portefeuille détenu par un dépositaire institutionnel qualifié.",
    "charity.walletBadge.safeLabel":
      "Trésorerie multisignature · {{threshold}} signatures sur {{count}}",
    "charity.walletBadge.safeTooltip":
      "Les dons sont versés à un portefeuille multisignature nécessitant plusieurs approbations avant tout mouvement de fonds.",
    "wallet.eoa.chain": "Réseau",
    "wallet.eoa.checkAuthorized":
      "Je suis autorisé(e) par mon organisation à désigner ce portefeuille comme adresse de réception des dons caritatifs.",
    "wallet.eoa.checkRisk":
      "Je comprends qu'un portefeuille à signataire unique présente un risque plus élevé qu'un portefeuille multisignature, et que la perte de la clé privée entraîne une perte permanente des fonds.",
    "wallet.eoa.confirmSubtitle":
      "Veuillez confirmer les points suivants avant d'enregistrer ce portefeuille.",
    "wallet.eoa.confirmTitle": "Confirmation finale",
    "wallet.eoa.connectFirst": "Veuillez d'abord connecter votre portefeuille.",
    "wallet.eoa.connectWallet": "Connecter le portefeuille",
    "wallet.eoa.missingSignature":
      "Signature manquante. Veuillez revenir en arrière et signer à nouveau.",
    "wallet.eoa.proceedAnyway": "Je comprends, continuer",
    "wallet.eoa.register": "Enregistrer le portefeuille",
    "wallet.eoa.registering": "Enregistrement...",
    "wallet.eoa.rejected": "La demande de signature a été rejetée.",
    "wallet.eoa.riskParagraph1":
      "Un portefeuille à signataire unique (EOA) est contrôlé par une seule clé privée. Si cette clé est perdue, volée ou compromise, tous les fonds envoyés à ce portefeuille sont définitivement irrécupérables.",
    "wallet.eoa.riskParagraph2":
      "Pour les fonds d'une organisation, nous recommandons fortement d'utiliser un portefeuille multisignature Safe à la place. Les portefeuilles multisignatures nécessitent plusieurs approbations pour chaque transaction, ce qui protège contre les points de défaillance uniques.",
    "wallet.eoa.riskParagraph3":
      "En continuant, vous reconnaissez que Give Protocol n'est pas responsable de toute perte de fonds résultant de la compromission, de la perte ou de la mauvaise gestion de la clé privée.",
    "wallet.eoa.riskTitle":
      "Portefeuille à signataire unique : risques importants",
    "wallet.eoa.signError":
      "Échec de la signature du message. Veuillez réessayer.",
    "wallet.eoa.signMessage": "Signer le message de vérification",
    "wallet.eoa.signSubtitle":
      "Connectez votre portefeuille et signez un message pour prouver que vous contrôlez cette adresse.",
    "wallet.eoa.signTitle": "Connecter et signer",
    "wallet.eoa.useMultisig": "Utiliser un multisignature à la place",
    "wallet.eoa.walletConnection": "Portefeuille",
    "wallet.eoa.walletToRegister": "Portefeuille à enregistrer",
    "wallet.institutional.address": "Adresse du portefeuille",
    "wallet.institutional.attestation": "Document d'attestation",
    "wallet.institutional.attestationHelp":
      "Téléversez un fichier PDF, JPEG ou PNG (max 10 Mo) prouvant votre relation de dépôt.",
    "wallet.institutional.backToWallets": "Retour aux portefeuilles",
    "wallet.institutional.chain": "Réseau",
    "wallet.institutional.chooseFile": "Choisir un fichier ou glisser-déposer",
    "wallet.institutional.custodian": "Dépositaire",
    "wallet.institutional.fileTooLarge":
      "Le fichier doit être inférieur à 10 Mo.",
    "wallet.institutional.invalidAddress":
      "Veuillez saisir une adresse Ethereum valide (0x...)",
    "wallet.institutional.invalidFileType":
      "Veuillez téléverser un fichier PDF, JPEG ou PNG.",
    "wallet.institutional.removeFile": "Supprimer le fichier",
    "wallet.institutional.selectCustodian":
      "Veuillez sélectionner un dépositaire.",
    "wallet.institutional.selectCustodianOption":
      "Sélectionner un dépositaire...",
    "wallet.institutional.submit": "Soumettre pour examen",
    "wallet.institutional.submittedDesc":
      "L'enregistrement de votre portefeuille institutionnel est en cours d'examen. Vous recevrez un e-mail sous 3 jours ouvrés.",
    "wallet.institutional.submittedTitle": "Portefeuille soumis pour examen",
    "wallet.institutional.submitting": "Soumission en cours...",
    "wallet.institutional.subtitle":
      "Fournissez les détails de votre portefeuille géré par un dépositaire et téléversez un document d'attestation pour vérification.",
    "wallet.institutional.title":
      "Enregistrer un portefeuille de dépôt institutionnel",
    "wallet.institutional.uploadFile": "Téléverser le fichier d'attestation",
    "wallet.institutional.uploadRequired":
      "Veuillez téléverser un document d'attestation.",
    "wallet.safe.address": "Adresse du Safe",
    "wallet.safe.chain": "Réseau",
    "wallet.safe.connectFirst":
      "Veuillez d'abord connecter votre portefeuille signataire.",
    "wallet.safe.connectSigner": "Connecter le portefeuille signataire",
    "wallet.safe.createNew": "Créer un nouveau Safe",
    "wallet.safe.createNewDesc":
      "Ouvre app.safe.global où vous pouvez créer un nouveau multisignature. Revenez ici une fois déployé.",
    "wallet.safe.haveOne": "J'ai déjà un Safe",
    "wallet.safe.haveOneDesc":
      "Saisissez l'adresse de votre Safe et vérifiez le contrôle en signant un message depuis un portefeuille signataire.",
    "wallet.safe.invalidAddress":
      "Veuillez saisir une adresse Ethereum valide (0x...)",
    "wallet.safe.rejected": "La demande de signature a été rejetée.",
    "wallet.safe.signError":
      "Échec de la signature du message de vérification. Veuillez réessayer.",
    "wallet.safe.signVerify": "Signer pour vérifier",
    "wallet.safe.signerWallet": "Portefeuille signataire",
    "wallet.safe.subtitle":
      "Un Safe nécessite plusieurs signataires pour approuver chaque transaction, offrant le plus haut niveau de sécurité pour les fonds de votre association.",
    "wallet.safe.title": "Configurer un portefeuille multisignature Safe",
    "wallet.safe.verifyTitle": "Vérifier la propriété du Safe",
    "wallet.safe.verifying": "Vérification en cours...",
    "wallet.setup.addAnother": "Ajouter un autre",
    "wallet.setup.custodian": "Dépositaire",
    "wallet.setup.deleteFailed": "Échec de la suppression du portefeuille",
    "wallet.setup.eoaDesc":
      "Un portefeuille standard contrôlé par une seule clé privée. Le plus simple mais le moins sécurisé pour un usage organisationnel.",
    "wallet.setup.eoaTitle": "Signataire unique (EOA)",
    "wallet.setup.institutionalDesc":
      "Géré par un dépositaire qualifié (Fireblocks, Anchorage, etc.). Nécessite un document d'attestation.",
    "wallet.setup.institutionalTitle": "Dépôt institutionnel",
    "wallet.setup.makePrimary": "Définir comme principal",
    "wallet.setup.primary": "Principal",
    "wallet.setup.primaryFailed":
      "Échec de la mise à jour du portefeuille principal",
    "wallet.setup.primaryUpdated": "Portefeuille principal mis à jour",
    "wallet.setup.recommended": "Recommandé",
    "wallet.setup.remove": "Supprimer le portefeuille",
    "wallet.setup.safeDesc":
      "Plusieurs signataires requis pour chaque transaction. Sécurité maximale pour les fonds organisationnels.",
    "wallet.setup.safeSigners": "Signataires",
    "wallet.setup.safeTitle": "Safe multisignature",
    "wallet.setup.subtitle":
      "Choisissez comment votre association recevra les dons en crypto-monnaie. Nous recommandons un portefeuille multisignature pour une sécurité maximale.",
    "wallet.setup.title": "Configurer votre portefeuille de réception",
    "wallet.setup.viewExplorer": "Voir sur l'explorateur de blocs",
    "wallet.setup.walletAdded": "Portefeuille enregistré avec succès",
    "wallet.setup.walletDeleted": "Portefeuille supprimé",
    "wallet.setup.walletsTitle": "Portefeuilles de réception",
    "admin.nav.dashboard": "Tableau de bord",
    "admin.nav.reports": "Rapports et analyses",
    "admin.nav.charities": "Associations",
    "admin.nav.donations": "Dons",
    "admin.nav.impactMetrics": "Indicateurs d'impact",
    "admin.nav.portfolioFunds": "Fonds du portefeuille",
    "admin.nav.contentModeration": "Modération de contenu",
    "admin.nav.settings": "Paramètres système",
    "admin.nav.overview": "Vue d'ensemble",
    "admin.nav.operations": "Opérations",
    "admin.nav.consoleLabel": "Console d'administration",
    "admin.shell.searchPlaceholder":
      "Rechercher donateurs, associations, hash de transaction…",
    "admin.shell.searchLabel": "Rechercher dans la console d'administration",
    "admin.shell.notifications": "Notifications",
    "admin.shell.adminLabel": "administrateur",
    "admin.shell.superAdmin": "Super administrateur",
    "admin.shell.signOut": "Se déconnecter",
    "admin.shell.backToPublicSite": "Retour au site public",
    "admin.shell.homeLink": "Accueil Give Protocol",
    "admin.dashboard.severityHigh": "Priorité élevée",
    "admin.dashboard.severityMedium": "Attention requise",
    "admin.dashboard.severityLow": "À examiner",
    "admin.dashboard.alertOldest": "Demande la plus ancienne soumise",
    "admin.dashboard.alertReviewHint":
      "examen pour ne pas ralentir l'intégration",
    "admin.dashboard.reviewQueue": "File d'examen",
    "admin.dashboard.kpiDonorsSub":
      "{{count}} nouveaux au cours des 30 derniers jours",
    "admin.dashboard.kpiPending": "{{count}} en attente",
    "admin.dashboard.awaitingVerification": "En attente de vérification",
    "admin.dashboard.kpiVerifiedSub": "sur {{total}} au total approuvés",
    "admin.dashboard.kpiVolunteersActive": "Inscriptions actives",
    "admin.dashboard.kpiVolunteersSub": "Aucune inscription active",
    "admin.dashboard.donationVolume": "Volume de dons",
    "admin.dashboard.donationVolumeSub": "{{range}} · crypto + fiat combinés",
    "admin.dashboard.range30d": "30 derniers jours",
    "admin.dashboard.range90d": "90 derniers jours",
    "admin.dashboard.rangeYtd": "Depuis le début de l'année",
    "admin.dashboard.volumeEmptyTitle": "Aucun don enregistré pour le moment",
    "admin.dashboard.volumeEmptySub":
      "Le volume s'affichera ici dès que le premier don sera réglé",
    "admin.dashboard.totalVolume": "Volume total",
    "admin.dashboard.crypto": "Crypto",
    "admin.dashboard.fiat": "Fiat",
    "admin.dashboard.activitySubtitle":
      "Événements de la plateforme au fur et à mesure",
    "admin.dashboard.viewAllActivity": "Voir toute l'activité",
    "admin.dashboard.viewAllDonations": "Voir tous les dons",
    "admin.charity.tabAll": "Toutes",
    "admin.charity.review": "Examiner",
    "admin.charity.colOrganization": "Organisation",
    "admin.charity.colRaised": "Collecté",
    "admin.charity.colSubmitted": "Soumis",
    "admin.charity.searchAria": "Rechercher des associations",
    "admin.charity.reviewTitle": "Examiner {{name}}",
    "admin.charity.submittedRelative": "Soumis {{when}}",
    "admin.charity.contactEmail": "E-mail",
    "admin.charity.contactPhone": "Téléphone",
    "admin.charity.raisedUnavailable": "Aucun total de dons disponible",
    "admin.error.title": "Erreur de chargement des données",
    "admin.error.recentActivity": "Erreur de chargement de l'activité récente",
    "admin.error.alerts": "Erreur de chargement des alertes",
    "admin.error.donationVolume": "Erreur de chargement du volume de dons",
    "donation.gas.estimating": "Estimation des frais de réseau…",
    "donation.gas.label": "Frais de réseau est.",
    "donation.gas.highGasWarning":
      "Alerte frais élevés : les frais estimés sont de {{usd}}, soit {{pct}} de votre don.",
    "donation.gas.highGasSuggestion":
      "Envisagez un don plus important ou de passer à une chaîne à frais réduits.",
    "donation.gas.l2Hint": "Pour des frais réduits, essayez {{chains}}.",
  },
};
